<template>
  <div v-if="loadingStatus" class="body-max-width-background-color">
    <div class="body-max-width">
      <Header title=""></Header>
    </div>
    <div class="flex-mid">
      <div
        class="fs-18 fc-000000 pt-40"
        style="margin-left: -25px; margin-right: -25px; overflow: hidden"
      >
        <div class="pt-10 center" style="width: 100%; overflow: hidden">
          <img
            src="@/assets/image/Well_Line02_.gif"
            alt="Loading"
            class=""
            style="
              width: 120%;
              margin-left: -20px;
              height: 120%;
              object-fit: cover;
              overflow: hidden;
            "
          />
        </div>
        <div class="dialog-water">
          <div class="fs-18 fw-500 center">{{ $t("loading") }}</div>
        </div>
        <!-- <div class="center">{{ $t("loading") }}</div> -->
      </div>
    </div>
  </div>
  <div v-else class="body-max-width-background-color">
    <div class="relative body-max-width-no-padding" style="overflow: hidden">
      <img
        src="@/assets/image/Home/banner_total.png"
        alt="alexandr"
        class="bg-image-header"
      />
      <div class="home body-max-width">
        <Header title=""></Header>
        <div class="header" style="">
          <div
            @click="redirect('?coin')"
            class="coin-container flex-center mb-40"
          >
            <div class="value flex-center">
              <div class="text">{{ coinPattern(coin) }} Coins</div>
            </div>
            <div class="icon flex-mid">
              <img
                src="@/assets/image/Home/coin2.png"
                alt="coin"
                style="width: 50px; height: 50px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- if have hospital appointment -->
    <div v-if="haveAppointment" class="body-max-width">
      <div class="see-all-appointment">
        <p class="next-appointment">{{ $t("nextAppointment") }}</p>
        <p class="see-all" @click="seeAllAppointment">{{ $t("seeAll") }}</p>
      </div>
      <div
        class="hospital-visit-card"
        @click="seeHospitalVisit(appointmentData.appointmentId)"
      >
        <div v-if="currentGuardian" class="name flex-mid">
          <p class="text">
            {{ userData.firstName }}&nbsp;{{ userData.lastName }}&nbsp;{{
              $t("me")
            }}
          </p>
        </div>
        <div class="card-layout">
          <div class="appointment-date mx-auto">
            <div class="show-date">
              <div class="content">
                <div class="date flex-mid">{{ appointmentData.date }}</div>
                <div class="month flex-mid">{{ appointmentData.month }}</div>
              </div>
            </div>
            <div class="icon flex-mid">
              <svg
                width="18"
                height="20"
                viewBox="0 0 18 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 7H17"
                  stroke="#6DB557"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16 3H2C1.44772 3 1 3.44772 1 4V18C1 18.5523 1.44772 19 2 19H16C16.5523 19 17 18.5523 17 18V4C17 3.44772 16.5523 3 16 3Z"
                  stroke="#6DB557"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.5 13H6.5"
                  stroke="#6DB557"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9 10.5V15.5"
                  stroke="#6DB557"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13 1V3"
                  stroke="#6DB557"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5 1V3"
                  stroke="#6DB557"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div class="appointment-image">
            <img src="@/assets/image/NewDesign/health-checkup-package.png" />
          </div>
          <div class="appointment-detail">
            <p class="appointment-header">{{ $t("healthCheckup") }}</p>
            <div v-if="appointmentData.packageAmount > 1">
              <p class="appointment-header">
                {{ "( " + appointmentData.packageAmount }}
                {{ $t("manyPackage") + " )" }}
              </p>
            </div>
            <div v-else>
              <p class="appointment-header">
                {{ "( " + appointmentData.packageAmount }}
                {{ $t("package") + " )" }}
              </p>
            </div>
            <hr />
            <p class="hospital-visit">{{ $t("hospitalVisit") }}</p>
            <div class="location-box">
              <div class="hospital">
                <div class="icon">
                  <svg
                    width="14"
                    height="16"
                    viewBox="0 0 14 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.1225 3.46439C10.5909 3.9287 10.9626 4.47995 11.2161 5.08667C11.4696 5.69338 11.6 6.34367 11.6 7.00039C11.6 7.65711 11.4696 8.30739 11.2161 8.91411C10.9626 9.52082 10.5909 10.0721 10.1225 10.5364L6.55604 14.0704L2.98955 10.5354C2.5212 10.0711 2.14967 9.51976 1.89621 8.91306C1.64273 8.30635 1.51227 7.65608 1.51227 6.99939C1.51227 6.34269 1.64273 5.69243 1.89621 5.08572C2.14967 4.47901 2.5212 3.92774 2.98955 3.46339C3.45792 2.99903 4.01394 2.63069 4.62587 2.37938C5.23781 2.12807 5.89368 1.99873 6.55604 1.99873C7.2184 1.99873 7.87426 2.12807 8.4862 2.37938C9.09816 2.63069 9.65411 3.00003 10.1225 3.46439ZM11.1917 11.5964C12.1086 10.6874 12.733 9.52918 12.9861 8.26829C13.2391 7.0074 13.1092 5.70043 12.6131 4.51268C12.1169 3.32493 11.2766 2.30974 10.1985 1.59548C9.12025 0.881232 7.85272 0.5 6.55604 0.5C5.25935 0.5 3.99179 0.881232 2.91364 1.59548C1.8355 2.30974 0.995196 3.32493 0.498995 4.51268C0.00280384 5.70043 -0.126996 7.0074 0.126017 8.26829C0.379029 9.52918 1.00349 10.6874 1.92041 11.5964L5.48589 15.1324C5.62639 15.2718 5.79321 15.3824 5.97684 15.4578C6.16046 15.5333 6.35728 15.5721 6.55604 15.5721C6.7548 15.5721 6.95162 15.5333 7.13524 15.4578C7.31885 15.3824 7.48568 15.2718 7.62618 15.1324L11.1917 11.5964ZM6.55604 9.00039C7.09105 9.00039 7.60413 8.78967 7.98245 8.4146C8.36075 8.03953 8.57328 7.53082 8.57328 7.00039C8.57328 6.46995 8.36075 5.96125 7.98245 5.58617C7.60413 5.2111 7.09105 5.00039 6.55604 5.00039C6.02103 5.00039 5.50794 5.2111 5.12963 5.58617C4.75133 5.96125 4.53879 6.46995 4.53879 7.00039C4.53879 7.53082 4.75133 8.03953 5.12963 8.4146C5.50794 8.78967 6.02103 9.00039 6.55604 9.00039Z"
                      fill="#545454"
                    />
                  </svg>
                </div>
                <p class="hospital-name">
                  {{ $t(appointmentData.hospitalName) }}
                </p>
              </div>
              <div class="seperate-line">
                <p>|</p>
              </div>
              <div class="time">
                <p>{{ appointmentData.time }} {{ $t("timeOclock") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- didn't do risk assessment -->
    <!-- <div v-if="!haveRisk"> -->
    <div v-if="!haveRisk">
      <div class="pt-2 green-background" style="height: 6rem; width: 100%">
        <div class="first-page-box body-max-width" id="goToRiskAssesment">
          <div class="green-box" @click="goToQuestionaire()">
            <div class="man-in-box">
              <img src="@/assets/image/NewDesign/ManInMainBlock1.png" />
            </div>
            <div class="text-in-box">
              <div v-if="lang == 'th'">
                <p class="text1">{{ $t("doYouKnowYourRisk") }}</p>
                <p class="text2">{{ $t("findOutYourRisk") }}</p>
              </div>
              <div v-else>
                <p class="text3">{{ $t("doYouKnowYourRisk") }}</p>
                <p class="text4">{{ $t("findOutYourRisk") }}</p>
              </div>

              <div class="start-button flex-mid">
                <p>{{ $t("doTheTest") }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="body-max-width" style="z-index: 4">
          <p class="find-package">{{ $t("findPackage") }}</p>
          <div class="select-branch">
            <div class="icon flex-mid">
              <svg
                width="21"
                height="24"
                viewBox="0 0 21 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.212 4.72034C16.9622 5.45969 17.5574 6.33747 17.9634 7.30358C18.3695 8.26967 18.5784 9.30516 18.5784 10.3509C18.5784 11.3966 18.3695 12.4321 17.9634 13.3982C17.5574 14.3643 16.9622 15.2421 16.212 15.9814L10.5 21.6088L4.788 15.9798C4.03789 15.2405 3.44287 14.3626 3.03692 13.3965C2.63096 12.4304 2.42201 11.395 2.42201 10.3493C2.42201 9.3036 2.63096 8.26816 3.03692 7.30206C3.44287 6.33597 4.03789 5.45816 4.788 4.71875C5.53812 3.97933 6.42863 3.3928 7.40868 2.99263C8.38875 2.59246 9.43919 2.3865 10.5 2.3865C11.5608 2.3865 12.6112 2.59246 13.5913 2.99263C14.5714 3.3928 15.4618 3.97933 16.212 4.71875V4.72034ZM17.9243 17.6693C19.3928 16.2219 20.3929 14.3776 20.7982 12.3698C21.2034 10.362 20.9955 8.2809 20.2009 6.38959C19.4061 4.49827 18.0603 2.88174 16.3336 1.74439C14.6068 0.607054 12.5767 0 10.5 0C8.42326 0 6.39316 0.607054 4.66642 1.74439C2.93969 2.88174 1.59388 4.49827 0.799179 6.38959C0.00449056 8.2809 -0.203393 10.362 0.201826 12.3698C0.607045 14.3776 1.60716 16.2219 3.07569 17.6693L8.78607 23.2998C9.0111 23.5218 9.27828 23.6979 9.57238 23.818C9.86646 23.9382 10.1817 24 10.5 24C10.8183 24 11.1336 23.9382 11.4276 23.818C11.7217 23.6979 11.9889 23.5218 12.2139 23.2998L17.9243 17.6693ZM10.5 13.5356C11.3569 13.5356 12.1786 13.2 12.7845 12.6028C13.3904 12.0056 13.7308 11.1955 13.7308 10.3509C13.7308 9.50624 13.3904 8.69621 12.7845 8.09896C12.1786 7.50171 11.3569 7.16619 10.5 7.16619C9.64315 7.16619 8.82139 7.50171 8.2155 8.09896C7.60962 8.69621 7.26923 9.50624 7.26923 10.3509C7.26923 11.1955 7.60962 12.0056 8.2155 12.6028C8.82139 13.2 9.64315 13.5356 10.5 13.5356Z"
                  fill="#337375"
                />
              </svg>
            </div>
            <div>
              <p class="branch">{{ $t("branch") }}</p>

              <div class="selection">
                <select
                  class="select-hospital"
                  id="selectHospital"
                  v-model="selectHospital"
                  :placeholder="$t('choosehospital')"
                  @change="getPackage()"
                >
                  <option
                    v-for="item in hospitalList"
                    :key="item.hospitalId"
                    :value="item.hospitalId"
                  >
                    {{ item.hospitalName }}
                  </option>

                  <!-- <option :label="$t('sukhumvit')" value="1"></option>
                <option :label="$t('srinakarin')" value="2"></option>
                <option :label="$t('thonburi')" value="4"></option> -->
                  <!-- <el-option :label="$t('sriracha')" value="3"> </el-option>
        <el-option :label="$t('chonburi')" value="5"> </el-option>
        <el-option :label="$t('chinatown')" value="6"> </el-option> -->
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="white-background">
          <div class="search-part">
            <div class="body-max-width flex-mid search-box">
              <input
                :placeholder="$t('seacrhPlaceHolder')"
                v-model="searchPackage"
                type="text"
              />
              <button class="search-btn flex-mid" @click="searchData()">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_561_4144)">
                    <path
                      d="M12.8335 12.8335L9.13281 9.13281"
                      stroke="#FCFCFD"
                      stroke-width="2"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.83341 10.5001C8.41074 10.5001 10.5001 8.41074 10.5001 5.83341C10.5001 3.25609 8.41074 1.16675 5.83341 1.16675C3.25609 1.16675 1.16675 3.25609 1.16675 5.83341C1.16675 8.41074 3.25609 10.5001 5.83341 10.5001Z"
                      stroke="#FCFCFD"
                      stroke-width="2"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_561_4144">
                      <rect width="14" height="14" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </div>
          </div>
          <!-- category -->
          <div class="body-max-width menu-tab flex-mid">
            <swiper
              :slides-per-view="4"
              :space-between="1.5"
              :mousewheel="true"
              :virtualIndex="2"
              :pagination="{
                dynamicBullets: true,
              }"
            >
              <swiper-slide
                v-for="category in categoryGroup"
                :key="category.categoryName"
                @click="selectCategory(category)"
              >
                <div :class="`flex-mid circle-menu`">
                  <img :src="category.imageUrl" class="category-icon" />
                </div>
                <div class="circle-name flex-mid">
                  {{ category.categoryName }}
                </div>
              </swiper-slide>
            </swiper>
          </div>

          <div class="body-max-width package-group">
            <div class="package-header">
              <p class="popular-package">{{ $t("popularPackage") }}</p>
              <button class="see-all-package" @click="seeAllPackage()">
                {{ $t("seeAll") }}
              </button>
            </div>
            <!-- package box -->
            <div
              v-if="loadingPackage"
              style="text-align: center; font-size: 2rem; padding-top: 10rem"
              class="body-max-width"
            >
              <img
                src="@/assets/image/Well_Line02_.gif"
                alt="Loading"
                class=""
                style="
                  width: 100%;
                  margin: auto;
                  height: 90%;
                  object-fit: cover;
                  overflow: hidden;
                "
              />
            </div>

            <div v-for="Item in packageData" :key="Item.id">
              <div class="package-category">
                <p class="title">
                  {{
                    Item.categoryName == "BEST_SELLER" || "STH_RECOMMEND"
                      ? $t(Item.categoryName)
                      : Item.categoryName
                  }}
                </p>
              </div>

              <div
                class="package-box"
                v-for="detail in Item.package"
                :key="detail.id"
              >
                <div :class="`body ${detail.showPack ? 'show' : ''}`">
                  <div class="show-package-name">
                    <div>
                      <input
                        type="checkbox"
                        class="check-box"
                        v-model="detail.select"
                        @change="duplicateDetail()"
                      />
                    </div>
                    <img :src="detail.imageUrl" />
                    <div class="package-detail">
                      <p class="package-name">
                        {{ detail.packageName }}
                      </p>

                      <div
                        v-if="detail.isSubset"
                        class="package-detail-duplicate"
                      >
                        <p class="item-name">
                          {{ $t("someDetailDup") }}
                        </p>
                      </div>
                      <div class="price">
                        <p class="package-netprice">
                          {{ "฿" + numberWithCommasLine(detail.netPrice) }}
                        </p>
                        <p class="package-listprice">
                          {{ "฿" + numberWithCommasLine(detail.fullPrice) }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="body-max-width">
                    <ul v-if="detail.showPack" class="package-item">
                      <li
                        class="item-name"
                        v-for="data in detail.itemInformation"
                        :key="data.itemId"
                      >
                        <p v-for="name in data.name" :key="name.id">
                          {{ name }}
                        </p>
                      </li>
                    </ul>
                    <div class="package-description">
                      <p
                        v-for="des in detail.packageDescription"
                        :key="des.id"
                        class="item-name"
                      >
                        {{ des }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="footer" v-if="detail.itemInformation.length > 0">
                  <div
                    class="see-detail flex-mid"
                    @click="detail.showPack = !detail.showPack"
                  >
                    <div v-if="!detail.showPack" class="see-detail-box">
                      <p class="text">{{ $t("seeMore") }}</p>
                      <div class="icon">
                        <svg
                          width="11"
                          height="7"
                          viewBox="0 0 11 7"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.2453 0.290792C10.0579 0.104542 9.8045 0 9.54031 0C9.27612 0 9.02267 0.104542 8.83531 0.290792L5.24531 3.83079L1.70531 0.290792C1.51795 0.104542 1.2645 0 1.00031 0C0.736124 0 0.482672 0.104542 0.29531 0.290792C0.201582 0.383755 0.127187 0.494356 0.0764184 0.616216C0.0256497 0.738075 -0.000488281 0.868781 -0.000488281 1.00079C-0.000488281 1.1328 0.0256497 1.26351 0.0764184 1.38537C0.127187 1.50723 0.201582 1.61783 0.29531 1.71079L4.53531 5.95079C4.62827 6.04452 4.73887 6.11891 4.86073 6.16968C4.98259 6.22045 5.1133 6.24659 5.24531 6.24659C5.37732 6.24659 5.50803 6.22045 5.62989 6.16968C5.75175 6.11891 5.86235 6.04452 5.95531 5.95079L10.2453 1.71079C10.339 1.61783 10.4134 1.50723 10.4642 1.38537C10.515 1.26351 10.5411 1.1328 10.5411 1.00079C10.5411 0.868781 10.515 0.738075 10.4642 0.616216C10.4134 0.494356 10.339 0.383755 10.2453 0.290792Z"
                            fill="#2D7617"
                          />
                        </svg>
                      </div>
                    </div>
                    <div v-else class="see-detail-box">
                      <p class="text">{{ $t("seeLess") }}</p>
                      <div class="icon">
                        <svg
                          width="11"
                          height="7"
                          viewBox="0 0 11 7"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.295218 5.9553C0.48258 6.14155 0.736032 6.24609 1.00022 6.24609C1.2644 6.24609 1.51785 6.14155 1.70522 5.9553L5.29522 2.4153L8.83522 5.9553C9.02258 6.14155 9.27603 6.24609 9.54022 6.24609C9.8044 6.24609 10.0579 6.14155 10.2452 5.9553C10.3389 5.86234 10.4133 5.75174 10.4641 5.62988C10.5149 5.50802 10.541 5.37731 10.541 5.2453C10.541 5.11329 10.5149 4.98258 10.4641 4.86072C10.4133 4.73887 10.3389 4.62826 10.2452 4.5353L6.00522 0.295301C5.91225 0.201572 5.80165 0.127179 5.67979 0.0764099C5.55794 0.025641 5.42723 -0.000497311 5.29522 -0.000497323C5.16321 -0.000497334 5.0325 0.025641 4.91064 0.0764098C4.78878 0.127179 4.67818 0.201572 4.58522 0.295301L0.295218 4.5353C0.20149 4.62826 0.127095 4.73886 0.0763265 4.86072C0.0255576 4.98258 -0.000581642 5.11329 -0.000581654 5.2453C-0.000581665 5.37731 0.0255576 5.50802 0.0763264 5.62988C0.127095 5.75174 0.201489 5.86234 0.295218 5.9553Z"
                            fill="#2D7617"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="seperate-category" />
            </div>
          </div>
        </div>
      </div>

      <div
        :class="`animated-footer ${totalAmount.total > 0 ? 'show' : 'hide'}`"
      >
        <div class="footer-navbar">
          <p class="total">{{ $t("total") }}</p>
          <!-- <p>{{ totalAmount.total }}</p> -->
          <div class="price">
            <p class="total-netprice">
              {{ "฿" + numberWithCommasLine(totalAmount.total) }}
            </p>
            <p class="total-listprice">
              {{ "฿" + numberWithCommasLine(totalAmount.fullTotal) }}
            </p>
          </div>
          <div>
            <button class="checkout-button" @click="checkOut()">
              {{ $t("checkout") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- already do risk assessment -->
    <div v-else>
      <div class="pt-2 green-background" style="height: 6rem; width: 100%">
        <div
          :class="`${
            haveAppointment ? 'show-risk-level-2' : 'show-risk-level'
          }`"
        >
          <div class="your-risk-header body-max-width flex-mid">
            <p class="title">{{ $t("riskScore") }}</p>
            <div class="test-again" @click="testAgain()">
              <svg
                width="12"
                height="18"
                viewBox="0 0 12 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 3.86937V6.19098L9 3.09549L6 0V2.32162C2.685 2.32162 0 5.09208 0 8.5126C0 9.72758 0.345 10.8574 0.93 11.8093L2.025 10.6794C1.6875 10.0371 1.5 9.29422 1.5 8.5126C1.5 5.95108 3.5175 3.86937 6 3.86937ZM11.07 5.2159L9.975 6.34576C10.305 6.99581 10.5 7.73099 10.5 8.5126C10.5 11.0741 8.4825 13.1558 6 13.1558V10.8342L3 13.9297L6 17.0252V14.7036C9.315 14.7036 12 11.9331 12 8.5126C12 7.29762 11.655 6.16777 11.07 5.2159Z"
                  fill="#545454"
                />
              </svg>

              <p class="text">{{ $t("testAgain") }}</p>
            </div>
          </div>
          <!-- <div v-if="riskScoreList.length == 0" class="no-risk body-max-width">
            <div class="no-suggest-package">
              <div class="text p-10">
                <div class="center">
                  <div class="mt-10">
                    <img
                      src="@/assets/image/NewDesign/no-risk.png"
                      style="width: 4rem"
                    />
                  </div>
                  <div class="fs-16 fw-500 mt-10">{{ $t("noRisk") }}</div>
                </div>
                <div></div>
                <p class="fs-16 fw-400">{{ $t("suggest") }}</p>

                <div
                  v-if="!showNoRisk"
                  class="fs-14 fw-400"
                  v-html="$t('nothaverisksuggest')"
                ></div>
                <div
                  v-else
                  class="fs-14 fw-400"
                  v-html="$t('nothaverisksuggest2')"
                ></div>
              </div>

              <div class="">
                <div @click="showNoRisk = !showNoRisk" class="footer flex-mid">
                  <hr />
                  <div v-if="showNoRisk" class="footer-nav flex-mid">
                    <p class="text">{{ $t("seeLess") }}</p>
                    <div class="icon">
                      <svg
                        width="11"
                        height="7"
                        viewBox="0 0 11 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.295218 5.9553C0.48258 6.14155 0.736032 6.24609 1.00022 6.24609C1.2644 6.24609 1.51785 6.14155 1.70522 5.9553L5.29522 2.4153L8.83522 5.9553C9.02258 6.14155 9.27603 6.24609 9.54022 6.24609C9.8044 6.24609 10.0579 6.14155 10.2452 5.9553C10.3389 5.86234 10.4133 5.75174 10.4641 5.62988C10.5149 5.50802 10.541 5.37731 10.541 5.2453C10.541 5.11329 10.5149 4.98258 10.4641 4.86072C10.4133 4.73887 10.3389 4.62826 10.2452 4.5353L6.00522 0.295301C5.91225 0.201572 5.80165 0.127179 5.67979 0.0764099C5.55794 0.025641 5.42723 -0.000497311 5.29522 -0.000497323C5.16321 -0.000497334 5.0325 0.025641 4.91064 0.0764098C4.78878 0.127179 4.67818 0.201572 4.58522 0.295301L0.295218 4.5353C0.20149 4.62826 0.127095 4.73886 0.0763265 4.86072C0.0255576 4.98258 -0.000581642 5.11329 -0.000581654 5.2453C-0.000581665 5.37731 0.0255576 5.50802 0.0763264 5.62988C0.127095 5.75174 0.201489 5.86234 0.295218 5.9553Z"
                          fill="#2D7617"
                        />
                      </svg>
                    </div>
                  </div>
                  <div v-else class="footer-nav flex-mid">
                    <p class="text">{{ $t("seeMore") }}</p>
                    <div class="icon">
                      <svg
                        width="11"
                        height="7"
                        viewBox="0 0 11 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.2453 0.290792C10.0579 0.104542 9.8045 0 9.54031 0C9.27612 0 9.02267 0.104542 8.83531 0.290792L5.24531 3.83079L1.70531 0.290792C1.51795 0.104542 1.2645 0 1.00031 0C0.736124 0 0.482672 0.104542 0.29531 0.290792C0.201582 0.383755 0.127187 0.494356 0.0764184 0.616216C0.0256497 0.738075 -0.000488281 0.868781 -0.000488281 1.00079C-0.000488281 1.1328 0.0256497 1.26351 0.0764184 1.38537C0.127187 1.50723 0.201582 1.61783 0.29531 1.71079L4.53531 5.95079C4.62827 6.04452 4.73887 6.11891 4.86073 6.16968C4.98259 6.22045 5.1133 6.24659 5.24531 6.24659C5.37732 6.24659 5.50803 6.22045 5.62989 6.16968C5.75175 6.11891 5.86235 6.04452 5.95531 5.95079L10.2453 1.71079C10.339 1.61783 10.4134 1.50723 10.4642 1.38537C10.515 1.26351 10.5411 1.1328 10.5411 1.00079C10.5411 0.868781 10.515 0.738075 10.4642 0.616216C10.4134 0.494356 10.339 0.383755 10.2453 0.290792Z"
                          fill="#2D7617"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div class="risk-group body-max-width">
            <div
              v-for="risk in riskScoreList"
              :key="risk.riskId"
              class="risk-card"
            >
              <div class="risk-header flex-mid">
                <div class="icon center">
                  <div class="icon-background">
                    <img
                      v-if="risk.riskId == 1"
                      src="@/assets/image/NewDesign/IconDisease/cardiovascular.png"
                      style="width: 4rem"
                    />
                    <img
                      v-else-if="risk.riskId == 2"
                      src="@/assets/image/NewDesign/IconDisease/diabetes.png"
                      style="width: 4rem"
                    />
                    <img
                      v-else-if="risk.riskId == 3"
                      src="@/assets/image/NewDesign/IconDisease/coloncancer.png"
                      style="width: 4rem"
                    />
                    <img
                      v-else-if="risk.riskId == 4"
                      src="@/assets/image/NewDesign/IconDisease/stroke.png"
                      style="width: 4rem"
                    />
                    <img
                      v-else-if="risk.riskId == 5"
                      src="@/assets/image/NewDesign/IconDisease/metabolic.png"
                      style="width: 4rem"
                    />
                    <img
                      v-else-if="risk.riskId == 6"
                      src="@/assets/image/NewDesign/IconDisease/lungcancer.png"
                      style="width: 4rem"
                    />
                  </div>
                </div>
                <div
                  :class="`risk-level ${
                    risk.severity == 3
                      ? 'high'
                      : risk.severity == 2
                      ? 'moderate'
                      : 'low'
                  }`"
                >
                  <p class="risk-level-text">{{ risk.severityName }}</p>
                </div>
              </div>

              <p class="risk-title">{{ risk.riskName }}</p>

              <div class="suggestion" @click="seeSuggestion(risk)">
                <p class="suggestion-link">{{ $t("suggestHeader") }}</p>
                <div class="arrow">
                  <svg
                    width="20"
                    height="16"
                    viewBox="0 0 20 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 7C0.447715 7 0 7.44772 0 8C0 8.55228 0.447715 9 1 9V7ZM19.7071 8.70711C20.0976 8.31658 20.0976 7.68342 19.7071 7.29289L13.3431 0.928932C12.9526 0.538408 12.3195 0.538408 11.9289 0.928932C11.5384 1.31946 11.5384 1.95262 11.9289 2.34315L17.5858 8L11.9289 13.6569C11.5384 14.0474 11.5384 14.6805 11.9289 15.0711C12.3195 15.4616 12.9526 15.4616 13.3431 15.0711L19.7071 8.70711ZM1 9H19V7H1V9Z"
                      fill="#2D7617"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="lowAllRisk"
            class="body-max-width mb-20"
            style="font-size: 1.2rem; color: #2d7617"
          >
            <p
              class="flex-mid pb-20"
              style="text-align: left"
              v-html="$t('noRiskNew')"
            ></p>
          </div>
        </div>
        <div class="white-background-2">
          <div class="body-max-width">
            <div class="select-package">
              <p class="select-package-header">{{ $t("bookYourPackage") }}</p>
              <button class="see-all-package" @click="seeAllPackage()">
                {{ $t("seeAll") }}
              </button>
            </div>
            <p class="analyzed-package">{{ $t("analyzedPackage") }}</p>
            <div class="select-branch">
              <div class="icon flex-mid">
                <svg
                  width="21"
                  height="24"
                  viewBox="0 0 21 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16.212 4.72034C16.9622 5.45969 17.5574 6.33747 17.9634 7.30358C18.3695 8.26967 18.5784 9.30516 18.5784 10.3509C18.5784 11.3966 18.3695 12.4321 17.9634 13.3982C17.5574 14.3643 16.9622 15.2421 16.212 15.9814L10.5 21.6088L4.788 15.9798C4.03789 15.2405 3.44287 14.3626 3.03692 13.3965C2.63096 12.4304 2.42201 11.395 2.42201 10.3493C2.42201 9.3036 2.63096 8.26816 3.03692 7.30206C3.44287 6.33597 4.03789 5.45816 4.788 4.71875C5.53812 3.97933 6.42863 3.3928 7.40868 2.99263C8.38875 2.59246 9.43919 2.3865 10.5 2.3865C11.5608 2.3865 12.6112 2.59246 13.5913 2.99263C14.5714 3.3928 15.4618 3.97933 16.212 4.71875V4.72034ZM17.9243 17.6693C19.3928 16.2219 20.3929 14.3776 20.7982 12.3698C21.2034 10.362 20.9955 8.2809 20.2009 6.38959C19.4061 4.49827 18.0603 2.88174 16.3336 1.74439C14.6068 0.607054 12.5767 0 10.5 0C8.42326 0 6.39316 0.607054 4.66642 1.74439C2.93969 2.88174 1.59388 4.49827 0.799179 6.38959C0.00449056 8.2809 -0.203393 10.362 0.201826 12.3698C0.607045 14.3776 1.60716 16.2219 3.07569 17.6693L8.78607 23.2998C9.0111 23.5218 9.27828 23.6979 9.57238 23.818C9.86646 23.9382 10.1817 24 10.5 24C10.8183 24 11.1336 23.9382 11.4276 23.818C11.7217 23.6979 11.9889 23.5218 12.2139 23.2998L17.9243 17.6693ZM10.5 13.5356C11.3569 13.5356 12.1786 13.2 12.7845 12.6028C13.3904 12.0056 13.7308 11.1955 13.7308 10.3509C13.7308 9.50624 13.3904 8.69621 12.7845 8.09896C12.1786 7.50171 11.3569 7.16619 10.5 7.16619C9.64315 7.16619 8.82139 7.50171 8.2155 8.09896C7.60962 8.69621 7.26923 9.50624 7.26923 10.3509C7.26923 11.1955 7.60962 12.0056 8.2155 12.6028C8.82139 13.2 9.64315 13.5356 10.5 13.5356Z"
                    fill="#337375"
                  />
                </svg>
              </div>

              <div>
                <p class="branch">{{ $t("branch") }}</p>
                <div class="selection">
                  <select
                    class="select-hospital"
                    id="selectHospital"
                    v-model="selectHospital"
                    :placeholder="$t('choosehospital')"
                    @change="getPackage()"
                  >
                    <option
                      v-for="item in hospitalList"
                      :key="item.hospitalId"
                      :value="item.hospitalId"
                    >
                      {{ item.hospitalName }}
                    </option>
                    <!-- <option :label="$t('sukhumvit')" value="1"></option>
                  <option :label="$t('srinakarin')" value="2"></option>
                  <option :label="$t('thonburi')" value="4"></option> -->
                    <!-- <el-option :label="$t('sriracha')" value="3"> </el-option>
                  <el-option :label="$t('chonburi')" value="5"> </el-option>
                  <el-option :label="$t('chinatown')" value="6"> </el-option> -->
                  </select>
                </div>
              </div>
            </div>

            <div class="line">
              <hr width="100%" style="border: 1px solid #dbe7d4" />
            </div>
            <div class="show-package">
              <div
                v-if="loadingPackage"
                style="text-align: center; font-size: 2rem; padding-top: 10rem"
                class="body-max-width"
              >
                <img
                  src="@/assets/image/Well_Line02_.gif"
                  alt="Loading"
                  class=""
                  style="
                    width: 100%;
                    margin: auto;
                    height: 90%;
                    object-fit: cover;
                    overflow: hidden;
                  "
                />
              </div>
              <div v-for="Item in packageData" :key="Item.id">
                <div class="package-category">
                  <p class="title">
                    {{
                      Item.categoryName.includes("RECOMMEND")
                        ? $t("RECOMMEND")
                        : Item.categoryName == "BEST_SELLER"
                        ? $t(Item.categoryName)
                        : Item.categoryName
                    }}
                  </p>
                </div>
                <div
                  class="package-box"
                  v-for="detail in Item.package"
                  :key="detail.id"
                >
                  <div :class="`body ${detail.showPack ? 'show' : ''}`">
                    <div class="show-package-name">
                      <div>
                        <input
                          type="checkbox"
                          class="check-box"
                          v-model="detail.select"
                          @change="duplicateDetail()"
                        />
                      </div>

                      <img :src="detail.imageUrl" />
                      <div class="package-detail">
                        <div
                          v-if="detail.riskInformation != null"
                          :class="`${
                            lang == 'en' ? 'very-suggest-en' : 'very-suggest'
                          }`"
                        >
                          <div class="detail">
                            <div class="icon">
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_561_5916)">
                                  <path
                                    d="M4.47233 12.4444H2.72233C2.41291 12.4444 2.11617 12.3215 1.89737 12.1027C1.67858 11.8839 1.55566 11.5872 1.55566 11.2778V7.19444C1.55566 6.88502 1.67858 6.58827 1.89737 6.36948C2.11617 6.15069 2.41291 6.02777 2.72233 6.02777H4.47233M8.55566 4.8611V2.52777C8.55566 2.06364 8.37129 1.61852 8.0431 1.29033C7.71491 0.962146 7.26979 0.777771 6.80566 0.777771L4.47233 6.02777V12.4444H11.0523C11.3337 12.4476 11.6067 12.349 11.8211 12.1668C12.0355 11.9845 12.1768 11.731 12.219 11.4528L13.024 6.20277C13.0494 6.03556 13.0381 5.86483 12.9909 5.70242C12.9438 5.54 12.8619 5.38978 12.7509 5.26215C12.6399 5.13453 12.5025 5.03256 12.3482 4.96331C12.194 4.89406 12.0264 4.85919 11.8573 4.8611H8.55566Z"
                                    stroke="white"
                                    stroke-width="1.2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_561_5916">
                                    <rect width="14" height="14" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            <p class="text">{{ $t("mostRecommend") }}</p>
                          </div>
                        </div>

                        <p class="package-name flex-mid">
                          {{ detail.packageName }}
                        </p>

                        <div
                          v-if="detail.isSubset"
                          class="package-detail-duplicate"
                        >
                          <p class="item-name">
                            {{ $t("someDetailDup") }}
                          </p>
                        </div>
                        <div class="price">
                          <p class="package-netprice">
                            {{ "฿" + numberWithCommasLine(detail.netPrice) }}
                          </p>
                          <p class="package-listprice">
                            {{ "฿" + numberWithCommasLine(detail.fullPrice) }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="body-max-width">
                      <ul v-if="detail.showPack" class="package-item">
                        <li
                          class="item-name"
                          v-for="data in detail.itemInformation"
                          :key="data.itemId"
                        >
                          <p v-for="name in data.name" :key="name.id">
                            {{ name }}
                          </p>
                        </li>
                      </ul>

                      <div class="package-description">
                        <p
                          v-for="des in detail.packageDescription"
                          :key="des.id"
                          class="item-name"
                        >
                          {{ des }}
                        </p>
                      </div>
                      <div
                        v-if="detail.isCheckedPastYear"
                        class="package-description"
                      >
                        <p class="item-name">{{ $t("alreadyBuy") }}</p>
                      </div>
                    </div>
                  </div>

                  <div class="footer" v-if="detail.itemInformation.length > 0">
                    <div
                      class="see-detail flex-mid"
                      @click="detail.showPack = !detail.showPack"
                    >
                      <div v-if="!detail.showPack" class="see-detail-box">
                        <p class="text">{{ $t("seeMore") }}</p>
                        <div class="icon">
                          <svg
                            width="11"
                            height="7"
                            viewBox="0 0 11 7"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.2453 0.290792C10.0579 0.104542 9.8045 0 9.54031 0C9.27612 0 9.02267 0.104542 8.83531 0.290792L5.24531 3.83079L1.70531 0.290792C1.51795 0.104542 1.2645 0 1.00031 0C0.736124 0 0.482672 0.104542 0.29531 0.290792C0.201582 0.383755 0.127187 0.494356 0.0764184 0.616216C0.0256497 0.738075 -0.000488281 0.868781 -0.000488281 1.00079C-0.000488281 1.1328 0.0256497 1.26351 0.0764184 1.38537C0.127187 1.50723 0.201582 1.61783 0.29531 1.71079L4.53531 5.95079C4.62827 6.04452 4.73887 6.11891 4.86073 6.16968C4.98259 6.22045 5.1133 6.24659 5.24531 6.24659C5.37732 6.24659 5.50803 6.22045 5.62989 6.16968C5.75175 6.11891 5.86235 6.04452 5.95531 5.95079L10.2453 1.71079C10.339 1.61783 10.4134 1.50723 10.4642 1.38537C10.515 1.26351 10.5411 1.1328 10.5411 1.00079C10.5411 0.868781 10.515 0.738075 10.4642 0.616216C10.4134 0.494356 10.339 0.383755 10.2453 0.290792Z"
                              fill="#2D7617"
                            />
                          </svg>
                        </div>
                      </div>
                      <div v-else class="see-detail-box">
                        <p class="text">{{ $t("seeLess") }}</p>
                        <div class="icon">
                          <svg
                            width="11"
                            height="7"
                            viewBox="0 0 11 7"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0.295218 5.9553C0.48258 6.14155 0.736032 6.24609 1.00022 6.24609C1.2644 6.24609 1.51785 6.14155 1.70522 5.9553L5.29522 2.4153L8.83522 5.9553C9.02258 6.14155 9.27603 6.24609 9.54022 6.24609C9.8044 6.24609 10.0579 6.14155 10.2452 5.9553C10.3389 5.86234 10.4133 5.75174 10.4641 5.62988C10.5149 5.50802 10.541 5.37731 10.541 5.2453C10.541 5.11329 10.5149 4.98258 10.4641 4.86072C10.4133 4.73887 10.3389 4.62826 10.2452 4.5353L6.00522 0.295301C5.91225 0.201572 5.80165 0.127179 5.67979 0.0764099C5.55794 0.025641 5.42723 -0.000497311 5.29522 -0.000497323C5.16321 -0.000497334 5.0325 0.025641 4.91064 0.0764098C4.78878 0.127179 4.67818 0.201572 4.58522 0.295301L0.295218 4.5353C0.20149 4.62826 0.127095 4.73886 0.0763265 4.86072C0.0255576 4.98258 -0.000581642 5.11329 -0.000581654 5.2453C-0.000581665 5.37731 0.0255576 5.50802 0.0763264 5.62988C0.127095 5.75174 0.201489 5.86234 0.295218 5.9553Z"
                              fill="#2D7617"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="seperate-category" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="`animated-footer ${totalAmount.total > 0 ? 'show' : 'hide'}`"
      >
        <div class="footer-navbar">
          <p class="total">{{ $t("total") }}</p>
          <!-- <p>{{ totalAmount.total }}</p> -->
          <div class="price">
            <p class="total-netprice">
              {{ "฿" + numberWithCommasLine(totalAmount.total) }}
            </p>
            <p class="total-listprice">
              {{ "฿" + numberWithCommasLine(totalAmount.fullTotal) }}
            </p>
          </div>
          <div>
            <button class="checkout-button" @click="checkOut()">
              {{ $t("checkout") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="errorModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="errorModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" style="border-radius: 30px">
        <div class="modal-body">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span
              aria-hidden="true"
              @click="redirect('?mainapp')"
              style="font-size: 40px; padding-right: 10px"
              >&times;</span
            >
          </button>
          <div style="text-align: center">
            <Vue3Lottie :animationData="errorImg" :speed="1" />

            <h3>Something went wrong</h3>
            <p style="font-size: 12px">
              please try again later or contact us +66(0) 2022 2222
            </p>
            Error : {{ error }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="remove-padding-dialog-2">
    <el-dialog
      v-model="riskSuggestion"
      @closed="closeModalConfirm"
      width="35.5rem"
    >
      <div class="body-max-width">
        <div class="dialog-header flex-center">
          <div class="icon">
            <div class="icon-background">
              <img
                v-if="suggestionData.riskId == 1"
                src="@/assets/image/NewDesign/IconDisease/cardiovascular.png"
                style="width: 4rem"
              />
              <img
                v-else-if="suggestionData.riskId == 2"
                src="@/assets/image/NewDesign/IconDisease/diabetes.png"
                style="width: 4rem"
              />
              <img
                v-else-if="suggestionData.riskId == 3"
                src="@/assets/image/NewDesign/IconDisease/coloncancer.png"
                style="width: 4rem"
              />
              <img
                v-else-if="suggestionData.riskId == 4"
                src="@/assets/image/NewDesign/IconDisease/stroke.png"
                style="width: 4rem"
              />
              <img
                v-else-if="suggestionData.riskId == 5"
                src="@/assets/image/NewDesign/IconDisease/metabolic.png"
                style="width: 4rem"
              />
              <img
                v-else-if="suggestionData.riskId == 6"
                src="@/assets/image/NewDesign/IconDisease/lungcancer.png"
                style="width: 4rem"
              />
            </div>
          </div>
          <div class="risk-name">
            {{ suggestionData.riskName }}
          </div>
        </div>
        <hr width="100%" />
        <div class="dialog-palette">
          <div class="risk-header">{{ $t("riskTitle") }}</div>

          <div v-if="lang == 'th'" class="risklevel">
            <div v-if="suggestionData.maxSeverityLevel == 3">
              <div v-if="suggestionData.severity == 3">
                <img
                  src="@/assets/image/NewDesign/level/high-risk.png"
                  style="width: 100%"
                />
              </div>
              <div v-else-if="suggestionData.severity == 2">
                <img
                  src="@/assets/image/NewDesign/level/medium-risk.png"
                  style="width: 100%"
                />
              </div>
              <div v-else>
                <img
                  src="@/assets/image/NewDesign/level/low-risk.png"
                  style="width: 100%"
                />
              </div>
            </div>
            <div v-else>
              <div v-if="suggestionData.severity == 2">
                <img
                  src="@/assets/image/NewDesign/level/high-risk.png"
                  style="width: 100%"
                />
              </div>
              <div v-else>
                <img
                  src="@/assets/image/NewDesign/level/low-risk.png"
                  style="width: 100%"
                />
              </div>
            </div>
          </div>
          <div v-else class="risklevel">
            <div v-if="suggestionData.maxSeverityLevel == 3">
              <div v-if="suggestionData.severity == 3">
                <img
                  src="@/assets/image/NewDesign/level/high-risk-en.png"
                  style="width: 100%"
                />
              </div>
              <div v-else-if="suggestionData.severity == 2">
                <img
                  src="@/assets/image/NewDesign/level/medium-risk-en.png"
                  style="width: 100%"
                />
              </div>
              <div v-else>
                <img
                  src="@/assets/image/NewDesign/level/low-risk-en.png"
                  style="width: 100%"
                />
              </div>
            </div>
            <div v-else>
              <div v-if="suggestionData.severity == 2">
                <img
                  src="@/assets/image/NewDesign/level/high-risk-en.png"
                  style="width: 100%"
                />
              </div>
              <div v-else>
                <img
                  src="@/assets/image/NewDesign/level/low-risk-en.png"
                  style="width: 100%"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="dialog-suggest">
          <div class="suggest-header">{{ $t("suggestHeader") }}</div>
          <ul
            v-for="(suggest, i) in suggestionData.suggest"
            :key="i + '_' + suggestionData.id"
            class="suggest-detail left"
          >
            <li>{{ suggest }}</li>
          </ul>
          <div class="suggest-note">{{ suggestionData.note }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Header from "@/components/HomeNav.vue";
import "swiper/swiper.min.css";
//   import "swiper/modules/autoplay/autoplay.scss";
import axios from "axios";
// import * as config from "@/assets/js/config.js";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";
import "swiper/modules/navigation/navigation.min.css";
import SwiperCore, { EffectCoverflow, Pagination } from "swiper";
SwiperCore.use([EffectCoverflow, Pagination]);
import errorImg from "@/assets/image/36572-under-maintenance.json";
import Services from "@/services";

export default defineComponent({
  name: "Home2",
  components: {
    Header,
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      // modules: [Mousewheel],
    };
  },

  data() {
    return {
      errorImg,
      loadingStatus: true,
      channel: null,
      name: null,
      coin: 0,
      lang: "th",
      haveAppointment: false,
      appointmentId: "",
      appointmentData: "",
      searchPackage: "",
      accessToken: null,
      haveRisk: false,
      riskScoreList: [],
      lowAllRisk: false,
      showNoRisk: false,
      error: null,
      allPackageList: [],
      packageList: [],
      packageData: [],
      loadingPackage: true,
      dataList: [],
      selectHospital: 1,
      categoryId: null,
      genderFilter: "A",
      keyword: "",
      hospitalList: [],
      packageHospital: [],
      list: [],
      username: "",
      memberId: "",
      showDetail: false,
      riskSuggestion: false,
      suggestionData: [],
      loadData: false,
      showTotalNav: true,
      userData: [],
      currentGuardian: false,
      // Geolocation
      savePositon: {
        latitude: 0,
        longitude: 0,
      },
      currentPositon: {
        latitude: 0,
        longitude: 0,
      },
      distance: 0,
      errorAlert: null,
      categoryGroup: [],
      filterCategory: false,
      needCurrentPosition: true,
    };
  },
  mounted() {
    scrollTo(0, 0);
    this.channel = this.$cookies.get("channel");
    this.lang = this.$cookies.get("lang");
    this.username = this.$cookies.get("username");
    this.memberId = this.$cookies.get("memberId");
    this.$gtag.set("user_properties", {
      memberId: this.memberId,
    });
    window.localStorage.removeItem("selectHospital");
    this.accessToken = this.$cookies.get("access_token");
    this.appointmentId = this.$route.query.appointmentId
      ? this.$route.query.appointmentId
      : "";
    if (this.appointmentId != "") {
      this.seeHospitalVisitFromMain(this.appointmentId);
    }

    this.getAppointment();
    this.getCategory();
    // this.getPackage();
    this.getData();
  },
  updated() {
    if (this.needCurrentPosition) {
      this.loadingStatus = true;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.currentPositon = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            };

            this.getHospitalBranch();
            this.loadingStatus = false;
            this.needCurrentPosition = false;
          },
          (error) => {
            console.log(error);
            this.showError(error);
          },
          { enableHighAccuracy: false, timeout: 5000 }
        );
      } else {
        this.currentPositon.latitude = 0;
        this.currentPositon.longitude = 0;

        this.getHospitalBranch();
        this.loadingStatus = false;
        this.needCurrentPosition = false;
      }
    }
  },
  watch: {
    searchPackage() {
      if (this.searchPackage == "") {
        this.keyword = this.searchPackage;
        this.getPackage();
      }
    },
  },
  computed: {
    totalAmount: function () {
      const selectedItems = [];
      let total = 0;
      let fullTotal = 0;
      for (let i in this.packageData) {
        for (let item of this.packageData[i].package) {
          // const item = this.packageData[i];
          if (item.select && !selectedItems.includes(item.packageId)) {
            selectedItems.push(item.packageId); //+ ':1')
          }
        }
      }
      for (let i in this.selectPackageData) {
        if (
          this.selectPackageData[i].select &&
          !selectedItems.includes(this.selectPackageData[i].packageId)
        ) {
          selectedItems.push(this.selectPackageData[i].packageId); //+ ':1')
        }
      }
      const countPrice = [];
      for (let i in this.packageData) {
        // const item = this.packageData[i];
        for (let item of this.packageData[i].package) {
          if (item.select && !countPrice.includes(item.packageId)) {
            countPrice.push(item.packageId);
            selectedItems.shift(item.packageId);
            total += item.select ? item.netPrice : 0;
            fullTotal += item.select ? item.fullPrice : 0;
          }
        }
      }

      for (let i in this.selectPackageData) {
        if (
          this.selectPackageData[i].select &&
          !countPrice.includes(this.selectPackageData[i].packageId)
        ) {
          countPrice.push(this.selectPackageData[i]);
          selectedItems.shift(this.selectPackageData[i]);
          if (
            this.selectPackageData[i].prerequisite.length == 0 ||
            this.selectPackageData[i].prerequisite.some((ai) =>
              selectedItems.includes(ai)
            )
          ) {
            total += this.selectPackageData[i].select
              ? this.selectPackageData[i].netPrice
              : 0;
          } else {
            total += this.selectPackageData[i].select
              ? this.selectPackageData[i].fullPrice
              : 0;
          }
          fullTotal += this.selectPackageData[i].select
            ? this.selectPackageData[i].fullPrice
            : 0;
        }
      }

      return {
        fullTotal: fullTotal,
        total: total,
        selectedItems: selectedItems,
      };
    },
    SelectPackage: function () {
      const selectedItems = [];
      const selectedItemsData = [];

      for (let i in this.packageData) {
        for (let item of this.packageData[i].package) {
          if (item.select) {
            // if (!(selectedItems.includes(item.packageId))) {
            selectedItems.push(item.packageId);
            selectedItemsData.push(item);
            // }
          }
        }
      }

      for (let i in this.selectPackageData) {
        if (this.selectPackageData[i].select) {
          if (!selectedItems.includes(this.selectPackageData[i].packageId)) {
            selectedItems.push(this.selectPackageData[i].packageId);
            selectedItemsData.push(this.selectPackageData[i]);
          }
        }
      }
      for (let i in this.prerequisiteList) {
        if (this.prerequisiteList[i].select) {
          if (!selectedItems.includes(this.prerequisiteList[i].packageId)) {
            selectedItems.push(this.prerequisiteList[i].packageId);
            selectedItemsData.push(this.prerequisiteList[i]);
          }
        }
      }
      return selectedItemsData;
    },
  },
  methods: {
    redirect(redirect) {
      window.location.href = redirect;
    },
    duplicateDetail() {
      let subsetList = [];
      this.packageData.forEach((element) => {
        element.package.forEach((item) => {
          if (item.select && item.subsetPackageIds.length > 0) {
            item.subsetPackageIds.forEach((subset) => {
              subsetList.push(subset);
            });
          }
        });
      });
      this.packageData.forEach((element) => {
        element.package.forEach((item) => {
          item.isSubset = false;
          if (item.select && subsetList.includes(item.packageId)) {
            item.isSubset = true;
          }
        });
      });
    },

    searchData() {
      if (this.searchPackage != "") {
        this.keyword = this.searchPackage;
        // this.getPackage();
        this.$router.push({
          name: "showAllPackage",
          query: {
            keyword: this.keyword,
            hospitalId: this.selectHospital,
          },
        });
      }
    },
    goToQuestionaire() {
      this.$gtag.event("click_questionaire_button", {
        event_category: "Home_page",
        event_label: "click questionaire button",
      });
      this.$router.push("/question");
    },
    seeAllAppointment() {
      this.$router.push({
        path: "/all-appointment",
      });
    },
    checkOut() {
      const selectedPackageList = [];
      for (let i = 0; i < this.SelectPackage.length; i++) {
        selectedPackageList.push(this.SelectPackage[i].packageId);
      }
      this.$store.commit("setSelectedHospital", this.selectHospital);
      this.$store.commit("setSelectedPackageList", selectedPackageList);
      console.log(
        this.$store.state.selectedPackageList,
        this.$store.state.selectedHospital
      );
      this.$router.push({
        name: "Booking",
      });
    },
    seeHospitalVisit(value) {
      this.$router.push({
        path: "/appointment-detail",
        query: { appointmentId: value },
      });
    },
    seeHospitalVisitFromMain(value) {
      this.$router.push({
        path: "/appointment-detail",
        query: { appointmentId: value, well: true },
      });
    },
    getCategory() {
      axios
        .get(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/hospital-package/get-package-categories",
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((res) => {
          const category = res.data;
          category.forEach((element) => {
            element.select = false;
          });
          this.categoryGroup = category;
        })
        .catch((error) => {
          this.error = error;
          window.$("#errorModal").modal("show");
        });
    },
    selectCategory(category) {
      this.$router.push({
        name: "showAllPackage",
        query: {
          categoryId: category.categoryId,
          hospitalId: this.selectHospital,
        },
      });
      this.getPackage();
    },
    getAppointment() {
      axios
        .get(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/appointment/get",

          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((res) => {
          const data = res.data;
          const appDetail = [];
          if (data.length != 0) {
            for (let i = 0; i < data.length; i++) {
              this.haveAppointment = true;
              const dateTime = new Date(data[i].primaryDateTime);
              const date = dateTime.getDate();
              let month = "";
              if (this.lang == "th") {
                month = dateTime.toLocaleString("th-TH", {
                  month: "short",
                });
              } else {
                month = dateTime.toLocaleString("en-EN", {
                  month: "short",
                });
              }

              const time = dateTime.toLocaleString("default", {
                hour: "numeric",
                minute: "numeric",
                hour12: false,
              });

              appDetail.push({
                date: date,
                month: month,
                time: time,
                hospitalName: data[i].site,
                appointmentCode: data[i].appointmentCode,
                appointmentId: data[i].appointmentId,
                packageAmount: data[i].packageNumber,
              });
            }
          }
          appDetail.sort((a, b) => a.date - b.date);

          this.appointmentData = appDetail[0];
        })
        .catch((error) => {
          this.error = error;
          window.$("#errorModal").modal("show");
        });
    },
    testAgain() {
      this.$gtag.event("click_testagain_button", {
        event_category: "Home_page",
        event_label: "click test again button",
      });
      this.$router.push("/question");
    },
    numberWithCommasLine(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ".-";
    },
    coinPattern(num) {
      if (num < 900) {
        return num; // if value < 1000, nothing to do
      } else if (num < 1000000) {
        return (num / 1000).toFixed(1) + "K"; // convert to K for number from > 1000 < 1 million
      } else if (num < 1000000000) {
        return (num / 1000000).toFixed(1) + "M"; // convert to M for number from > 1 million
      } else {
        return (num / 1000000000).toFixed(1) + "B"; // convert to M for number from > 1 million
      }
    },
    seeSuggestion(data) {
      (this.suggestionData = data), (this.riskSuggestion = true);
    },
    seeAllPackage() {
      this.$gtag.event("click_seeAll_button", {
        event_category: "Home_page",
        event_label: "click see all button",
      });
      this.$router.push("/show-all-package");
      this.$router.push({
        path: "/show-all-package",
        query: { hospitalId: this.selectHospital },
      });
    },
    getData() {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/customer/get",
          {},
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((res) => {
          console.log(res.data);
          this.userData = res.data.customer;
          if (this.userData.gender != null) {
            this.$cookies.set("gender", this.userData.gender);
            this.genderFilter = this.userData.gender;
          } else {
            this.$cookies.set("gender", "A");
          }

          if (this.userData.currentGuardian != null) {
            this.currentGuardian = true;
          }
          let result = res.data;
          if (result.coin != null) {
            this.coin = result.coin;
          }
          this.name = result.customer.firstName;
          if (result.riskAssessment.risks.length > 0) {
            let risks = [];
            this.haveRisk = true;
            for (let i = 0; i < result.riskAssessment.risks.length; i++) {
              let risk = result.riskAssessment.risks[i];
              if (risk.severity > 0) {
                risk["showStatus"] = false;
                risk["status"] =
                  risk.maxSeverityLevel == 2
                    ? risk.severity == 1
                      ? "low"
                      : "high"
                    : risk.severity == 1
                    ? "low"
                    : risk.severity == 2
                    ? "moderate"
                    : "high";
                if (risk.riskRecommendation.match(/\*.+/g)) {
                  risk["note"] = risk.riskRecommendation
                    .match(/\*.+/g)
                    .toString();
                  risk.riskRecommendation = risk.riskRecommendation.replace(
                    /\*.+/g,
                    ""
                  );
                } else {
                  // risk["note"] = risk.riskRecommendation;
                  let index = risk.riskRecommendation.match("Note");
                  risk["note"] = risk.riskRecommendation.substring(index.index);
                  risk.riskRecommendation.riskRecommendation =
                    risk.riskRecommendation.substring(0, index.index);
                }

                risk["suggest"] = risk.riskRecommendation
                  .replace(/^[ ]*-/g, "")
                  .split("\n-");
                risks.push(risk);
              }
            }
            risks.sort((a, b) => b.severity - a.severity);
            this.riskScoreList = risks;
            // check if all this.riskScoreList.severity == 1
            let allRisk = true;
            for (let i = 0; i < this.riskScoreList.length; i++) {
              if (this.riskScoreList[i].severity != 1) {
                allRisk = false;
              }
            }
            this.lowAllRisk = allRisk;
          }
          // customer
          // const customer = res.data.customer;
          // riskScore
          const riskScore = res.data.riskAssessment.risks;
          // Riskrecommendationpack
          const healthPackage = [];
          for (let i = 0; i < riskScore.length; i++) {
            const recommended = riskScore[i]["recommendationPackage"];
            if (recommended != null && recommended.length > 0) {
              for (let j = 0; j < recommended.length; j++) {
                riskScore[i]["recommendationPackage"][j]["select"] =
                  riskScore[i]["recommendationPackage"][j]["selected"] > 0;
              }
              healthPackage.push({
                categoryName: riskScore[i].riskName,
                severityName: riskScore[i].severityName,
                severity: riskScore[i].severity,
                maxSeverity: riskScore[i].maxSeverityLevel,
                riskId: riskScore[i].riskId,
                statusShow: true,
                seeDetail: false,
                package: riskScore[i]["recommendationPackage"],
              });
            }
          }
          this.dataList = healthPackage;
          for (let item of res.data.recommendationPackages) {
            item.select = item.selected > 0;
          }
          const data = this.groupBy(
            res.data.recommendationPackages,
            "categoryName"
          );

          for (const property in data) {
            this.dataList.push({
              categoryName: property,
              severityName: null,
              severity: null,
              riskId: null,
              maxSeverity: null,
              statusShow: true,
              seeDetail: false,
              package: data[property],
            });
          }

          for (let x in this.dataList) {
            for (let z in this.dataList[x].package) {
              this.dataList[x].package[z].available = true;
              this.dataList[x].package[z].showPack = false;
            }
          }

          for (let i in this.dataList) {
            for (let j in this.dataList[i].package) {
              if (this.dataList[i].package[j].subSetPackage.length != 0) {
                for (let x in this.dataList) {
                  for (let z in this.dataList[x].package) {
                    if (
                      this.dataList[i].package[j].subSetPackage.includes(
                        this.dataList[x].package[z].packageId
                      )
                    ) {
                      if (this.dataList[i].package[j].selected == 1) {
                        this.dataList[x].package[z].selected = -1;
                        this.dataList[x].package[z].select = false;
                        this.dataList[x].package[z].available = false;
                      }
                      // this.list[x].package[z].available = false;
                    }
                  }
                }
              }
            }
          }
          this.loadingStatus = false;
          // this.packageData = this.dataList;
          this.packageList = this.dataList;
        })
        .catch((error) => {
          if (error.response.status == 403) {
            this.getNewToken();
          } else {
            // this.loadingStatus = false;
            this.error = error;
            window.$("#errorModal").modal("show");
          }
        });
    },
    getPackage() {
      Services.getPackages(
        this.selectHospital,
        this.categoryId,
        this.genderFilter,
        this.keyword,
        this.lang,
        this.accessToken
      )
        .then((res) => {
          console.log(res.data);
          const data = res.data.hospitalPackageBean;
          const hospitalPackagesData = data.hospitalPackages;
          const maxPackages = 4;
          const riskPackages = [];
          let haveRiskPackage = false;
          let hospitalPackages = hospitalPackagesData.filter(
            (hospitalPackage) => hospitalPackage.searchType == "RISK_SCORE"
          );
          const bestSellerPackages = hospitalPackagesData.filter(
            (hospitalPackage) => hospitalPackage.searchType == "BEST_SELLER"
          );
          const sumPackage = [];
          hospitalPackagesData.forEach((item) =>
            item.itemInformation.forEach(
              (item2) => (item2.name = item2.name.split("\n"))
            )
          );

          for (let i = 0; i < hospitalPackagesData.length; i++) {
            for (let j = 0; j < this.riskScoreList.length; j++) {
              if (hospitalPackagesData[i].riskInformation != null) {
                if (
                  hospitalPackagesData[i].riskInformation.riskId ==
                  this.riskScoreList[j].riskId
                ) {
                  hospitalPackagesData[i].riskInformation.severity =
                    this.riskScoreList[j].severity;
                }
              }
            }
          }

          hospitalPackages.forEach((element) => {
            if (element.subsetPackageIds.length != 0) {
              element.subsetPackageIds.forEach((subset) => {
                hospitalPackages.forEach((element2) => {
                  if (element2.packageId == subset) {
                    element2.isSubset = true;
                  }
                });
              });
            }
          });

          hospitalPackages.forEach((element) => {
            if (element.riskInformations.length != 0) {
              haveRiskPackage = true;
              var categoryName = "";
              element.riskInformations.forEach((risk) => {
                // if (categoryName != "") {
                //   categoryName += " ";
                // }
                categoryName = risk.riskName;
              });

              riskPackages.push({
                categoryName:
                  categoryName ?? element.riskInformations[0]?.riskName ?? "",
                hospitalPackageId: element.hospitalPackageId,
                itemInformation: element.itemInformation,
                packageId: element.packageId,
                packageName: element.packageInformation.packageName,
                packageDescription:
                  element.packageInformation.packageDescription.split("\n"),
                fullPrice: element.packageInformation.fullPrice,
                netPrice: element.packageInformation.netPrice,
                packageInformation: element.packageInformation,
                imageUrl: element.packageInformation.imageUrl,
                riskInformation: element.riskInformations,
                intervalDays: element.packageInformation.intervalDays,
                specialtyCode: element.packageInformation.specialtyCode,
                practitionerId: element.packageInformation.practitionerId,
                showPack: false,
                subsetPackageIds: element.subsetPackageIds,
                isSubset: false,
                isCheckedPastYear: element.isCheckedPastYear,
              });
            }
          });

          let riskPackageGrouped = this.groupBy(riskPackages, "categoryName");

          if (haveRiskPackage) {
            Object.keys(riskPackageGrouped).forEach((property) => {
              riskPackageGrouped[property].forEach((item) => {
                sumPackage.push({
                  categoryName: property,
                  hospitalPackageId: item.hospitalPackageId,
                  itemInformation: item.itemInformation,
                  packageId: item.packageId,
                  packageName: item.packageInformation.packageName,
                  packageDescription:
                    item.packageInformation.packageDescription.split("\n"),
                  fullPrice: item.packageInformation.fullPrice,
                  netPrice: item.packageInformation.netPrice,
                  packageInformation: item.packageInformation,
                  imageUrl: item.packageInformation.imageUrl,
                  riskInformation: item.riskInformation,
                  intervalDays: item.packageInformation.intervalDays,
                  specialtyCode: item.packageInformation.specialtyCode,
                  practitionerId: item.packageInformation.practitionerId,
                  showPack: false,
                  subsetPackageIds: item.subsetPackageIds,
                  isSubset: false,
                  select: true,
                  isCheckedPastYear: item.isCheckedPastYear,
                });
              });
            });
          }
          if (bestSellerPackages.length > 0) {
            let bestSellerPackageGrouped = this.groupBy(
              bestSellerPackages,
              "searchType"
            );
            Object.keys(bestSellerPackageGrouped).forEach((property) => {
              bestSellerPackageGrouped[property].forEach((item) => {
                sumPackage.push({
                  categoryName: property,
                  hospitalPackageId: item.hospitalPackageId,
                  itemInformation: item.itemInformation,
                  packageId: item.packageId,
                  packageName: item.packageInformation.packageName,
                  packageDescription:
                    item.packageInformation.packageDescription.split("\n"),
                  fullPrice: item.packageInformation.fullPrice,
                  netPrice: item.packageInformation.netPrice,
                  packageInformation: item.packageInformation,
                  imageUrl: item.packageInformation.imageUrl,
                  riskInformation: item.riskInformation,
                  intervalDays: item.packageInformation.intervalDays,
                  specialtyCode: item.packageInformation.specialtyCode,
                  practitionerId: item.packageInformation.practitionerId,
                  showPack: false,
                  subsetPackageIds: item.subsetPackageIds,
                  isSubset: false,
                  select: false,
                  isCheckedPastYear: item.isCheckedPastYear,
                });
              });
            });
          }

          if (sumPackage.length < maxPackages) {
            const STHHospitalPackages = hospitalPackagesData.filter(
              (hospitalPackage) => hospitalPackage.searchType == "STH_RECOMMEND"
            );
            const STHHospitalPackagesGroup = this.groupBy(
              STHHospitalPackages,
              "searchType"
            );
            Object.keys(STHHospitalPackagesGroup).forEach((property) => {
              STHHospitalPackagesGroup[property].forEach((item) => {
                sumPackage.push({
                  categoryName: property,
                  hospitalPackageId: item.hospitalPackageId,
                  itemInformation: item.itemInformation,
                  packageId: item.packageId,
                  packageName: item.packageInformation.packageName,
                  packageDescription:
                    item.packageInformation.packageDescription.split("\n"),
                  fullPrice: item.packageInformation.fullPrice,
                  netPrice: item.packageInformation.netPrice,
                  packageInformation: item.packageInformation,
                  imageUrl: item.packageInformation.imageUrl,
                  riskInformation: item.riskInformation,
                  intervalDays: item.packageInformation.intervalDays,
                  specialtyCode: item.packageInformation.specialtyCode,
                  practitionerId: item.packageInformation.practitionerId,
                  showPack: false,
                  subsetPackageIds: item.subsetPackageIds,
                  isSubset: false,
                  select: false,
                  isCheckedPastYear: item.isCheckedPastYear,
                });
              });
            });
          }

          var tempData = [];
          let groupedData = this.groupBy(sumPackage, "categoryName");
          for (const property in groupedData) {
            const recommendPackage = {
              categoryName: property,
              package: groupedData[property],
            };
            tempData.push(recommendPackage);
          }

          this.packageData = tempData;
          this.duplicateDetail();
          this.loadingPackage = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    filterPackage() {
      let filterPackage = this.allPackageList.filter(
        (apackage) =>
          (
            apackage.packageName +
            " " +
            apackage.categoryName +
            " " +
            apackage.hospitalName +
            " " +
            apackage.packageDescription
          )
            .toLowerCase()
            .indexOf(this.searchPagckage.toLowerCase()) >= 0
      );
      this.packageList = filterPackage;
    },
    groupBy(xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    async getLocation() {
      // if (navigator.geolocation) {
      //   // navigator.geolocation.getCurrentPosition(this.showPosition);
      //   navigator.geolocation.getCurrentPosition(
      //     this.showPosition,
      //     this.showError,
      //     { enableHighAccuracy: false, timeout: 5000 }
      //   );
      // } else {
      //   this.error = "Geolocation is not supported by this browser.";
      // }
      // if (!window.flutter_inappwebview) {
      //   try {
      //     window.flutter_inappwebview
      //       .callHandler("getCurrentPosition")
      //       .then((position) => {
      //         this.currentPositon.latitude = position.coords.latitude;
      //         this.currentPositon.longitude = position.coords.longitude;
      //         this.getHospitalBranch();
      //       })
      //       .catch((error) => {
      //         this.showError;
      //       });
      //   } catch {
      //     this.currentPositon.latitude = 0;
      //     this.currentPositon.longitude = 0;
      //     this.getHospitalBranch();
      //   }
      // } else {
      //   this.currentPositon.latitude = 0;
      //   this.currentPositon.longitude = 0;
      //   this.getHospitalBranch();
      // }
    },
    showPosition(position) {
      this.currentPositon.latitude = position.coords.latitude;
      this.currentPositon.longitude = position.coords.longitude;
      this.getHospitalBranch();
    },
    showError(error) {
      console.log(error);
      this.loadingStatus = false;
      switch (error.code) {
        case error.PERMISSION_DENIED:
          this.needCurrentPosition = false;
          this.errorAlert = "User denied the request for Geolocation.";
          break;
        case error.POSITION_UNAVAILABLE:
          this.errorAlert = "Location information is unavailable.";
          break;
        case error.TIMEOUT:
          this.error = "The request to get user location timed out.";
          break;
        case error.UNKNOWN_ERROR:
          this.errorAlert = "An unknown error occurred.";
          break;
      }
      this.currentPositon.latitude = 0;
      this.currentPositon.longitude = 0;
      this.getHospitalBranch();
    },
    getHospitalBranch() {
      // currentPositon
      this.hospitalList = [];
      axios
        .get(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/hospital/location/get",
          {
            params: {
              lat: this.currentPositon.latitude,
              lng: this.currentPositon.longitude,
            },
            headers: {
              // 'x-api-key': HEALTH_DIARY_API_KEY,
              Authorization: "Bearer " + this.accessToken,
              accept: "application/json; charset=UTF-8",
              "Accept-Language": this.lang,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          let locationList = res.data;
          this.hospitalList = locationList;
          // close for dev
          this.selectHospital = this.hospitalList[0].hospitalId;
          this.getPackage();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
});
</script>

<style lang="scss" scoped>
.bg-image-header {
  width: 39.6rem;
  // width:100%;
  // height: 28.6rem;
  height: 30rem;
  position: absolute;
  bottom: -3rem;
  right: 0rem;
  z-index: -9;
  object-fit: contain;

  @media only screen and (min-width: 614px) {
    right: 22vw;
  }

  @media only screen and (min-width: 1000px) {
    right: 30vw;
  }

  @media only screen and (max-width: 370px) {
    width: 35rem;
  }

  @media only screen and (max-width: 320px) {
    width: 32rem;
  }

  @media only screen and (max-width: 300px) {
    width: 29rem;
  }
}

.green-background {
  // background: #ecf5ca;
  margin-top: 10rem;

  .first-page-box {
    margin-top: -100px;

    .green-box {
      display: grid;
      grid-template-columns: 40% 60%;
      gap: 0.5rem;
      height: 21.1rem;
      width: 100%;
      border-radius: 4.7rem;
      background: #77cf9a;
      margin: 0 auto;
      margin-top: 40px;
      z-index: -1;

      .man-in-box {
        // position: sticky;
        margin-top: -3.9rem;
        margin-left: -2.5rem;
        bottom: 0;
        display: block;
        width: 100%;
        // height: 100%;
        object-fit: contain;
        z-index: 0;

        img {
          height: 25rem;
        }
      }

      .text-in-box {
        width: 100%;
        padding: 1rem;
        height: 100%;
        z-index: 1;
        object-fit: contain;

        .text1 {
          font-size: 2.4rem;
          font-weight: 500;
          line-height: 33.5px;
        }

        .text2 {
          width: 100%;
          font-size: 1.4rem;
          font-weight: 400;
          line-height: 24px;
          word-break: break-word;
        }

        .text3 {
          font-size: 2rem;
          font-weight: 500;
          line-height: 33.5px;
        }

        .text4 {
          width: 100%;
          font-size: 1.2rem;
          font-weight: 400;
          line-height: 24px;
          word-break: break-word;
        }

        .start-button {
          margin-top: 1rem;
          height: 32px;
          width: 143px;
          border: none;
          border-radius: 30px;
          font-size: 1.4rem;
          font-weight: 400;
          background: #003824;
          color: #ffffff;

          p {
            margin: auto;
          }
        }
      }
    }

    // .man-in-box{
    // position: absolute;
    // margin: 0rem 1rem -3.5rem 0.5rem;
    // bottom: 0;
    // left: 0;
    // width: 50%;
    // height: 100%;
    // object-fit: contain;

    // @media only screen and (max-width: 500px) {
    //   margin: 0rem 1rem -1rem -0.5rem;
    //   width: 70%;
    // height: 100%;
    // }
    // }
  }

  .find-package {
    margin-top: 4rem;
    font-size: 20px;
    font-weight: 500;
    z-index: 2;
  }

  .select-branch {
    display: grid;
    grid-template-columns: 10% auto;
    gap: 1rem;
    margin-bottom: 5rem;

    .icon {
    }

    .branch {
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: left;
      margin-bottom: 0rem;
    }

    .selection {
      display: flex;

      .select-hospital {
        font-size: 1.8rem;
        font-weight: 500;
        color: #337375;
        height: 4.1rem;
        width: 100%;
        background: transparent;
        background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAHCAYAAADebrddAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACaSURBVHgBdY2xDYMwEEXvbCTaZIJU2SFllC5dVvAIKZFIZMQAWYENkiqiQ+xB4RFoKcxxBhlZRvzm7t//eofAupfll8cB9tWn1qpkXpFaIPjsVhGeP6179H6h02PTQ1H981y5Xfije8MEExHNKGXh7Vp2b4hQhV3n6yxbATIMu6Yx59v1yMgLARX1612FeQKRUkt6kOLERR1nE6iuMDbwTvnwAAAAAElFTkSuQmCC")
          no-repeat 95% 50%;
        -moz-appearance: none;
        -webkit-appearance: none;
        appearance: none;
        border: 0px;
        outline: 0px;
        border-radius: 4.1rem;
        margin-top: 0rem;

        @media only screen and (max-width: 300px) {
          font-size: 1.4rem;
        }
      }

      // .dropdown-arrow {
      //   height: 1rem;
      //   line-height: 4rem;
      //   margin-top: 1.5rem;
      //   margin-left: 0.5rem;
      // }
    }
  }
}

.see-all-appointment {
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: auto;
  margin-top: 1rem;

  .next-appointment {
    font-size: 18px;
    font-weight: 500;
    line-height: 27px;
  }

  .see-all {
    color: #2d7617;
    font-size: 16px;
    font-weight: 400;
    line-height: 27px;
    letter-spacing: 0.20000000298023224px;
    text-decoration: underline;
  }
}

.hospital-visit-card {
  margin-top: 1rem;
  width: 100%;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
    5px 5px 10px rgba(163, 162, 162, 0.25);

  .name {
    background: #abeb97;
    height: 3rem;
    border-radius: 15px 15px 0 0;
    display: flex;
    width: 100%;
    align-items: center;

    .text {
      font-size: 14px;
      font-weight: 400;
      line-height: 3rem;
      letter-spacing: 0em;
      color: #000000;
      margin: auto;
    }
  }

  .card-layout {
    width: 100%;
    display: grid;
    grid-template-columns: 25% 20% auto;
    gap: 1rem;
    padding: 1rem;

    .appointment-date {
      display: block;

      .show-date {
        background: #57b43c;
        width: 7rem;
        height: 7rem;
        border-radius: 7rem;
        padding: 1rem;

        .content {
          margin: auto;
          margin-top: 1rem;

          .date {
            margin: auto;
            color: #ffffff;
            font-size: 24px;
            font-weight: 500;
            line-height: 80%;
          }

          .month {
            margin: auto;
            color: #ffffff;
            font-size: 14px;
            font-weight: 500;
          }
        }
      }

      .icon {
        margin-top: 2rem;
      }
    }

    .appointment-image {
      display: block;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        overflow: hidden;
        border-radius: 12px;
      }
    }

    .appointment-detail {
      .appointment-header {
        color: #000000;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        letter-spacing: 0.20000000298023224px;
        text-align: left;
      }

      .hospital-visit {
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
      }

      hr {
        border: 2px #abeb97 solid;
        width: 100%;
      }

      .location {
        color: #545454;
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
      }

      .location-box {
        // display: inline-flex;
        color: #545454;
        font-size: 13px;
        // font-weight: 400;
        // line-height: 20px;
        // text-align: left;
        display: grid;
        grid-template-columns: 55% 10% 35%;

        .hospital {
          display: flex;

          .icon {
          }

          .hospital-name {
            margin-left: 0.5rem;
          }
        }

        .seperate-line {
          margin: 0 0.5rem 0 0.5rem;
        }

        .time {
        }
      }
    }
  }
}

.green-background:before {
  content: "";
  position: absolute;
  bottom: 50%;
  width: 100%;
  height: 60%;
  border-radius: 5%;
  box-shadow: 0px 300px 0px 300px #ecf5ca;
  z-index: -1;

  @media only screen and (min-width: 380px) {
    bottom: 60%;
  }
}

hr.seperate-category {
  border-top: 1px solid #dbe7d4;
}

.white-background {
  background: #ffffff;
  margin-bottom: 2rem;

  .search-part {
    margin-top: -2.5rem;
    position: absolute;
    z-index: 9;
    width: 100%;

    .search-box {
      margin: auto;
      background: #ffffff;
      display: flex;
      border: 2px solid #cceab5;
      border-radius: 9rem;
      width: 90%;
      height: 5rem;

      input {
        height: 4rem;
        width: 100%;

        border-radius: 9rem;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        border: none;
        padding: 1rem;
      }

      input:focus {
        outline: none;
        border: none;
      }

      // .search-btn {
      //   background: #2DC790;
      //   border: none;
      //   width: 3rem;
      //   height: 3rem;
      //   border-radius: 10rem;
      //   align-content: center;

      // }

      // .search-btn:hover {
      //   background: #0b8f60;
      //   outline: none;
      //   border: none;
      // }
    }
  }

  .menu-tab {
    margin-top: 2rem;
    margin-bottom: 1rem;
    display: block;

    .circle-menu {
      background: #ecf5ca;
      width: 6rem;
      height: 6rem;
      border-radius: 6rem;
      margin: auto;
      margin-top: 5rem;

      .category-icon {
        max-width: 5rem;
        max-height: 5rem;
      }
    }

    .circle-name {
      margin: auto;
      margin-top: 1rem;
      width: 60px;
      // height: 40px;
      top: 857px;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      text-align: center;
    }
  }

  .package-group {
    padding-bottom: 7rem;

    .package-header {
      display: inline-flex;
      width: 100%;
      justify-content: space-between;

      .popular-package {
        color: #23262f;
        font-size: 20px;
        font-weight: 500;
        line-height: 48px;
        letter-spacing: -0.01em;
        text-align: left;
      }

      .see-all-package {
        color: #2d7617;
        font-size: 16px;
        font-weight: 400;
        line-height: 48px;
        border: none;
        background: transparent;
        letter-spacing: 0.20000000298023224px;
      }
    }

    .package-category {
      margin-bottom: 2rem;

      .title {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
      }
    }

    .package-box {
      // border: #cceab5 1px solid;
      border: #cceab5 1px solid;
      position: relative;
      width: 100%;
      // max-height: 18.3rem;
      border-radius: 27px;
      margin: auto;
      margin-bottom: 2rem;
      // overflow: hidden;

      .body {
        // max-height: 13.3rem;
        overflow: hidden;

        .show-package-name {
          display: grid;
          grid-template-columns: 10% 40% auto;
          // margin: 0 0 2.6rem;
          margin: 1rem;
          padding: 1rem 1rem 0rem 1rem;

          .check-box {
            width: 24px;
            height: 24px;
            border-radius: 8px;
            border: #43b422 1px solid;
            accent-color: #4ea834;
            color: #ffffff;
          }

          .check-box:checked ~ .checkmark {
            background-color: #4ea834;
          }

          img {
            width: 12rem;
            height: 10rem;
            margin: 0rem auto;
            object-fit: cover;
            border-radius: 15px;
          }

          .package-detail {
            margin-left: 1rem;

            .very-suggest {
              background: #ff4343;
              width: 10rem;
              border-radius: 13px;
              margin-bottom: 2rem;

              .detail {
                display: inline-flex;
                height: 2.2rem;
                margin: auto;

                .icon {
                }

                .text {
                  margin-left: 1rem;
                  color: #ffffff;
                  font-size: 1.2rem;
                  line-height: 2.2rem;
                }
              }
            }

            .package-name {
              font-size: 16px;
              font-weight: 400;
              line-height: 24px;
              letter-spacing: 0em;
              text-align: left;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;

              @media only screen and (max-width: 400px) {
                font-size: 14px;
              }
            }

            .package-detail-duplicate {
              .item-name {
                color: #f57d0e;
                text-align: left;
                font-size: 14px;
                font-weight: 400;
                line-height: 21px;
              }
            }

            .price {
              display: grid;
              grid-template-columns: auto auto;
              gap: 1rem;

              .package-netprice {
                color: #ff3636;
                font-size: 18px;
                font-weight: 500;
                line-height: 33px;
                letter-spacing: 0em;
                text-align: left;
              }

              .package-listprice {
                color: #777e90;
                font-size: 12px;
                font-weight: 500;
                line-height: 33px;
                letter-spacing: 0em;
                text-align: left;
                text-decoration: line-through;
              }
            }
          }
        }

        .package-item {
          .item-name {
            color: #545454;
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
            letter-spacing: 0em;
            text-align: left;
          }
        }

        .package-description {
          .item-name {
            color: #c31212;
            text-align: left;
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
            margin-bottom: 1rem;
          }
        }
      }

      .body.show {
        overflow: auto;
        height: auto;
      }

      .see-detail {
        display: flex;
        // position: relative;
        bottom: 0;
        width: 100%;
        background: #ecf5ca;
        margin: auto;
        // padding: 2rem ;
        height: 35px;
        text-align: center;
        border-radius: 0rem 0rem 27px 27px;

        .see-detail-box {
          display: flex;

          .text {
            text-align: center;
            color: #2d7617;
            font-size: 12px;
            font-weight: 500;
            line-height: 18px;
            letter-spacing: 0em;
            text-align: left;
            margin: auto;
            text-decoration: underline;
          }

          .icon {
            line-height: 18px;
            margin-left: 1rem;
          }
        }
      }
    }
  }
}

.animated-footer {
  transform: translateY(100%);
  opacity: 0;
  transition: transform 0.5s linear;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 8rem;
  z-index: 3;

  .footer-navbar {
    position: fixed;
    bottom: 0;
    background: #ecf5ca;
    width: 100%;
    height: 8rem;
    z-index: 3;
    padding: 1rem;
    border-radius: 25px 25px 0 0;
    display: grid;
    grid-template-columns: 20% 30% 40%;
    gap: 1rem;
    filter: drop-shadow(5px 5px 5px rgba(148, 148, 148, 0.25));

    .total {
      color: #000000;
      font-size: 20px;
      font-weight: 400;
      line-height: 30px;
      letter-spacing: 0em;
      text-align: left;
      margin: auto;
      margin-top: 1rem;
    }

    .price {
      margin-top: 1rem;

      .total-netprice {
        font-size: 20px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: left;
        color: #000000;
      }

      .total-listprice {
        color: #9a9a9a;
        font-size: 16px;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: left;
        text-decoration: line-through;
      }
    }

    .checkout-button {
      margin-top: 1rem;
      height: 3.2rem;
      // width: 14.3rem;
      width: 100%;
      border: none;
      border-radius: 30px;
      font-size: 1.4rem;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: center;
      background: #ffffff;
      color: #000000;
      box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
        5px 5px 10px rgba(163, 162, 162, 0.25);
    }

    .checkout-button:focus {
      outline: none;
    }
  }
}

.animated-footer.show {
  transform: translateY(0);
  opacity: 1;
  transition: transform 0.5s linear;
}

.animated-footer.hide {
  transform: translateY(110%);
  transition: transform 1s linear;
  opacity: 1;
}

.header {
  // font-family: "Libre Caslon Text", serif;
  position: relative;

  .coin-container {
    margin-top: 13rem;
    height: 5.5rem;
    position: relative;

    .value {
      height: 3.6rem;
      min-width: 17.5rem;
      width: 17.5rem;
      height: 3.6rem;
      border-radius: 3.6rem;
      background-color: #429928;

      .text {
        margin-left: 5.5rem;
        width: calc(100% - 5.4rem);
        color: #fff;
        font-weight: 500;
        font-size: 18px;
        text-align: center;

        @media only screen and (min-width: 550px) {
          font-size: 23px;
        }
      }
    }

    .icon {
      width: 5.5rem;
      height: 5.5rem;
      border-radius: 5.5rem;
      // background-color: #fff;
      // box-shadow: 3px 4px 7px rgba(165, 165, 165, 0.25);
      position: absolute;
      top: 0;
      left: -3px;
    }
  }
}

.show-risk-level {
  margin-top: -80px;
  // background: #ecf5ca;

  .your-risk-header {
    display: flex;
    width: 100%;
    justify-content: space-between;

    .title {
      font-size: 1.8rem;
      font-weight: 500;
    }

    .test-again {
      display: inline-flex;
      font-size: 1.4rem;
      font-weight: 400;
      color: #545454;

      .text {
        margin-left: 1rem;
      }
    }
  }

  .risk-group {
    display: grid;
    grid-template-columns: 49% 49%;
    gap: 1rem;
    width: 100%;
    padding-bottom: 3rem;

    .risk-card {
      background: #ffffff;
      height: 138px;
      border-radius: 26px;
      padding: 1.5rem;
      box-shadow: 4px 4px 11px 0px #b7b7b733;
      box-shadow: -4px -2px 12px 0px #b7b7b733;

      .risk-header {
        display: inline-flex;
        width: 100%;
        justify-content: space-between;

        .icon {
          .icon-background {
            background: #f2f6ff;
            width: 4rem;
            height: 4rem;
            border-radius: 15px;
          }

          .icon-background.cardiovascular {
            background: #f2f6ff;
            width: 4rem;
            height: 4rem;
            border-radius: 15px;
          }

          .icon-background.metabolic-syndrome {
            background: #ebfbec;
            width: 4rem;
            height: 4rem;
            border-radius: 15px;
          }

          .icon-background.diabetes {
            background: #f2fada;
            width: 4rem;
            height: 4rem;
            border-radius: 15px;
          }

          .icon-background.colon-cancer {
            background: #f5f3e2;
            width: 4rem;
            height: 4rem;
            border-radius: 15px;
          }

          .icon-background.stroke {
            background: #eef8fa;
            width: 4rem;
            height: 4rem;
            border-radius: 15px;
          }

          .icon-background.lung-cancer {
            background: #fcf0e8;
            width: 4rem;
            height: 4rem;
            border-radius: 15px;
          }
        }

        .risk-level {
          background: #ffffff;
          // padding: 0 2rem;
          height: 2rem;
          width: 7rem;
          justify-content: center;
          border-radius: 13px;

          .risk-level-text {
            font-size: 1.2rem;
            color: #ffffff;
            font-weight: 400;
            line-height: 2rem;
            margin: auto;
            text-align: center;
          }
        }

        .risk-level.high {
          background-color: #ff4343;
        }

        .risk-level.moderate {
          background-color: #ecb447;
        }

        .risk-level.low {
          background-color: #4ab848;
        }
      }

      .risk-title {
        margin-top: 1rem;
        font-size: 16px;
        font-weight: 500;
        line-height: 21px;
        text-align: left;

        @media only screen and (max-width: 450px) {
          line-height: 16px;
        }
      }

      .suggestion {
        display: inline-flex;
        justify-content: space-between;
        width: 100%;

        // margin-top: 1rem;
        .suggestion-link {
          color: #2d7617;

          font-size: 12px;
          font-weight: 400;
          line-height: 20px;
          text-align: left;
          text-decoration: underline;

          @media only screen and (max-width: 450px) {
            line-height: 10px;
          }
        }

        .arrow {
          line-height: 20px;
          // margin: auto 0;
        }
      }
    }
  }
}

.show-risk-level-2 {
  margin-top: -80px;
  background: #ecf5ca;

  .your-risk-header {
    display: flex;
    width: 100%;
    justify-content: space-between;

    .title {
      font-size: 1.8rem;
      font-weight: 500;
    }

    .test-again {
      display: inline-flex;
      font-size: 1.4rem;
      font-weight: 400;
      color: #545454;

      .text {
        margin-left: 1rem;
      }
    }
  }

  .no-risk {
    width: 100%;
  }

  .risk-group {
    display: grid;
    grid-template-columns: 49% 49%;
    gap: 1rem;
    width: 100%;
    padding-bottom: 3rem;

    .risk-card {
      background: #ffffff;
      height: 138px;
      border-radius: 26px;
      padding: 1.5rem;
      box-shadow: 4px 4px 11px 0px #b7b7b733;
      box-shadow: -4px -2px 12px 0px #b7b7b733;

      .risk-header {
        display: inline-flex;
        width: 100%;
        justify-content: space-between;

        .icon {
          .icon-background {
            background: #f2f6ff;
            width: 4rem;
            height: 4rem;
            border-radius: 15px;
          }

          .icon-background.cardiovascular {
            background: #f2f6ff;
            width: 4rem;
            height: 4rem;
            border-radius: 15px;
          }

          .icon-background.metabolic-syndrome {
            background: #ebfbec;
            width: 4rem;
            height: 4rem;
            border-radius: 15px;
          }

          .icon-background.diabetes {
            background: #f2fada;
            width: 4rem;
            height: 4rem;
            border-radius: 15px;
          }

          .icon-background.colon-cancer {
            background: #f5f3e2;
            width: 4rem;
            height: 4rem;
            border-radius: 15px;
          }

          .icon-background.stroke {
            background: #eef8fa;
            width: 4rem;
            height: 4rem;
            border-radius: 15px;
          }

          .icon-background.lung-cancer {
            background: #fcf0e8;
            width: 4rem;
            height: 4rem;
            border-radius: 15px;
          }
        }

        .risk-level {
          background: #ffffff;
          // padding: 0 2rem;
          height: 2rem;
          width: 7rem;
          justify-content: center;
          border-radius: 13px;

          .risk-level-text {
            font-size: 1.2rem;
            color: #ffffff;
            font-weight: 400;
            line-height: 2rem;
            margin: auto;
            text-align: center;
          }
        }

        .risk-level.high {
          background-color: #ff4343;
        }

        .risk-level.moderate {
          background-color: #ecb447;
        }

        .risk-level.low {
          background-color: #4ab848;
        }
      }

      .risk-title {
        margin-top: 1rem;
        font-size: 16px;
        font-weight: 500;
        line-height: 21px;
        text-align: left;

        @media only screen and (max-width: 450px) {
          line-height: 16px;
        }
      }

      .suggestion {
        display: inline-flex;
        justify-content: space-between;
        width: 100%;

        // margin-top: 1rem;
        .suggestion-link {
          color: #2d7617;

          font-size: 12px;
          font-weight: 400;
          line-height: 20px;
          text-align: left;
          text-decoration: underline;

          @media only screen and (max-width: 450px) {
            line-height: 10px;
          }
        }

        .arrow {
          line-height: 20px;
          // margin: auto 0;
        }
      }
    }
  }
}

.white-background-2 {
  background: #ffffff;
  margin-bottom: 5rem;

  .select-package {
    padding-top: 3rem;
    display: inline-flex;
    width: 100%;
    justify-content: space-between;

    .select-package-header {
      color: #020202;
      font-size: 18px;
      font-weight: 500;
      line-height: 27px;
      letter-spacing: 0em;
      text-align: left;
    }

    .see-all-package {
      color: #2d7617;
      font-size: 16px;
      font-weight: 400;
      line-height: 27px;
      border: none;
      background: transparent;
      letter-spacing: 0.20000000298023224px;
      text-align: center;
      text-decoration: underline;
    }
  }

  .analyzed-package {
    color: #545454;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: left;
  }

  .select-branch {
    display: grid;
    grid-template-columns: 10% auto;
    gap: 1rem;
    margin-bottom: 1rem;

    .icon {
    }

    .branch {
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: left;
      margin-bottom: 0rem;
    }

    .selection {
      display: flex;

      .select-hospital {
        font-size: 1.8rem;
        font-weight: 500;
        color: #337375;
        height: 4.1rem;
        width: 100%;
        background: transparent;
        background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAHCAYAAADebrddAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACaSURBVHgBdY2xDYMwEEXvbCTaZIJU2SFllC5dVvAIKZFIZMQAWYENkiqiQ+xB4RFoKcxxBhlZRvzm7t//eofAupfll8cB9tWn1qpkXpFaIPjsVhGeP6179H6h02PTQ1H981y5Xfije8MEExHNKGXh7Vp2b4hQhV3n6yxbATIMu6Yx59v1yMgLARX1612FeQKRUkt6kOLERR1nE6iuMDbwTvnwAAAAAElFTkSuQmCC")
          no-repeat 95% 50%;
        -moz-appearance: none;
        -webkit-appearance: none;
        appearance: none;
        // background: #ffffff;
        border: 0px;
        outline: 0px;
        border-radius: 4.1rem;
        margin-top: 0rem;

        @media only screen and (max-width: 300px) {
          font-size: 1.4rem;
        }
      }

      // .dropdown-arrow {
      //   height: 1rem;
      //   line-height: 4rem;
      //   margin-top: 1.5rem;
      //   margin-left: 1rem;
      // }
    }
  }

  .line {
    margin: auto;
  }

  .show-package {
    padding-bottom: 8rem;

    .load-data {
      width: 100%;
      height: 100vh;
      z-index: 99;
    }

    .package-category {
      margin-bottom: 2rem;

      .title {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
      }
    }

    .package-box {
      // border: #cceab5 1px solid;
      border: #cceab5 1px solid;
      position: relative;
      width: 100%;
      // max-height: 18.3rem;
      border-radius: 27px;
      margin: auto;
      margin-bottom: 2rem;
      // overflow: hidden;

      .body {
        // max-height: 13.3rem;
        // padding: 1rem;
        overflow: hidden;

        .show-package-name {
          display: grid;
          grid-template-columns: 10% 40% auto;
          // margin: 0 0 2.6rem;
          // margin: 1rem;
          padding: 1rem 1rem 1rem 1rem;

          .check-box {
            width: 24px;
            height: 24px;
            border-radius: 8px;
            border: #43b422 1px solid;
            accent-color: #4ea834;
            color: #ffffff;
          }

          img {
            width: 12rem;
            height: 10rem;
            margin: 0rem auto;
            object-fit: cover;
            border-radius: 15px;
          }

          .package-detail {
            margin-left: 1rem;

            .very-suggest {
              background: #ff4343;
              width: 10rem;
              border-radius: 13px;
              text-align: center;

              .detail {
                display: flex;
                justify-content: space-between;
                margin: 10px;
                height: 2.2rem;
                //   margin: auto;
                // text-align: center;

                //   .icon {}

                .text {
                  //     margin-left: 1rem;
                  color: #ffffff;
                  font-size: 1.2rem;
                  line-height: 2.2rem;
                }
              }
            }

            .very-suggest-en {
              background: #ff4343;
              width: 11rem;
              border-radius: 13px;
              text-align: center;

              .detail {
                display: flex;
                justify-content: space-between;
                margin: 10px;
                height: 2.2rem;
                //   margin: auto;
                // text-align: center;

                //   .icon {}

                .text {
                  //     margin-left: 1rem;
                  color: #ffffff;
                  font-size: 1.2rem;
                  line-height: 2.2rem;
                }
              }
            }

            .package-name {
              font-size: 16px;
              font-weight: 400;
              line-height: 24px;
              letter-spacing: 0em;
              text-align: left;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;

              @media only screen and (max-width: 400px) {
                font-size: 14px;
              }
            }

            .package-detail-duplicate {
              .item-name {
                color: #f57d0e;
                text-align: left;
                font-size: 14px;
                font-weight: 400;
                line-height: 21px;
              }
            }

            .price {
              display: grid;
              grid-template-columns: auto auto;
              gap: 1rem;

              .package-netprice {
                color: #ff3636;
                font-size: 18px;
                font-weight: 500;
                line-height: 33px;
                letter-spacing: 0em;
                text-align: left;
              }

              .package-listprice {
                color: #777e90;
                font-size: 12px;
                font-weight: 500;
                line-height: 33px;
                letter-spacing: 0em;
                text-align: left;
                text-decoration: line-through;
              }
            }
          }
        }

        .package-item {
          .item-name {
            color: #545454;
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
            letter-spacing: 0em;
            text-align: left;
          }
        }

        .package-description {
          .item-name {
            color: #c31212;
            text-align: left;
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
            margin-bottom: 1rem;
          }
        }
      }

      .body.show {
        overflow: auto;
        height: auto;
      }

      .see-detail {
        // display: flex;
        // position: relative;
        bottom: 0;
        width: 100%;
        background: #ecf5ca;
        margin: auto;
        // padding: 2rem ;
        height: 35px;
        text-align: center;
        border-radius: 0rem 0rem 27px 27px;

        .see-detail-box {
          display: flex;

          .text {
            text-align: center;
            color: #2d7617;
            font-size: 12px;
            font-weight: 500;
            line-height: 18px;
            letter-spacing: 0em;
            text-align: left;
            margin: auto;
            text-decoration: underline;
          }

          .icon {
            line-height: 18px;
            margin-left: 1rem;
          }
        }
      }
    }
  }
}

.get-risk-container {
  // padding: 1rem;
  // width: calc(100% - 4rem);
  width: 100%;
  margin: 20px auto 26px;
  padding: 20px 20px 20px;
  box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
    5px 5px 10px rgba(163, 162, 162, 0.25);
  border-radius: 20px;
  display: grid;
  grid-template-columns: auto auto;
  gap: 1rem;

  .image {
    // background-color: red;
    height: 100%;
  }

  .content {
    width: 100%;
  }

  // @media only screen and (min-width: 714px) {
  //   grid-template-columns: auto auto;
  // }
}

.shadow {
  z-index: 99;
  height: 100%;
}

.btn-take-test {
  width: 15rem;
  height: 3.3rem;
  border-radius: 3.3rem;
  color: #000;
  box-shadow: none;
  font-size: 1.6rem;
  background: #d2e97a;

  &:hover {
    background: #d2e97a;
  }
}

.see-all-link {
  text-decoration: underline;
  color: #037968;
  font-size: 14px;
  cursor: pointer;
}

.no-suggest-package-new {
  background: #fff;
  border-radius: 15px;
  width: calc(100%);
  max-width: calc(400px + 4rem);
  margin: 1.6rem auto;
  box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
    5px 5px 10px rgba(163, 162, 162, 0.25);
  // height: 8rem;
  // font-size: 14px;
  // centering along main axis - X axis - Horizontal
  justify-content: center;
  // centering along cross axis - Y axis - Vertical
  align-items: center;

  // display: flex;
  .footer {
    height: 2.7rem;
    background: #ecf5ca;
    border-radius: 0 0 15px 15px;
    text-decoration: underline;
    cursor: pointer;

    .rotate {
      transform: rotate(180deg);
    }
  }
}

.no-suggest-package {
  background: #fff;
  border-radius: 15px;
  width: 100%;
  margin: 1.6rem auto;
  box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
    5px 5px 10px rgba(163, 162, 162, 0.25);
  // height: 8rem;
  // font-size: 14px;
  // centering along main axis - X axis - Horizontal
  justify-content: center;
  // centering along cross axis - Y axis - Vertical
  align-items: center;

  // display: flex;
  .footer {
    display: block;
    height: 4rem;
    width: 100%;
    background: #ffffff;
    text-decoration: underline;
    border-radius: 0 0 15px 15px;
    cursor: pointer;

    hr {
      border: 0.5px #cceab5 solid;
      width: 90%;
    }

    .footer-nav {
      display: flex;
      width: 100%;
      margin: auto;
      line-height: 1rem;
      margin-top: 1rem;

      .text {
        color: #2d7617;
        font-size: 1.2rem;
        // margin-top:1rem;
      }

      .icon {
        margin-left: 1rem;
        line-height: 3rem;
        margin-top: -1rem;
      }
    }
  }
}

.suggest-package {
  background: #fff;
  border-radius: 15px;
  width: calc(100% - 4rem);
  max-width: calc(400px + 4rem);
  margin: 1.6rem auto;
  box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
    5px 5px 10px rgba(163, 162, 162, 0.25);
  overflow: hidden;
  position: relative;

  .risk-status {
    position: absolute;
    top: 0;
    right: 2rem;
    width: 7rem;
    height: 2.7rem;
    border-radius: 0 0 1rem 1rem;
    color: #fff;
    font-weight: 500;
    font-size: 1.2rem;
    text-transform: capitalize;
    text-align: center;
  }

  .risk-status.high {
    background-color: #e45757;
  }

  .risk-status.moderate {
    background-color: #e7c74e;
  }

  .risk-status.low {
    background-color: #6db557;
  }

  .body {
    position: relative;
    padding: 2rem 0rem 1rem;
    word-wrap: break-word;

    .blur-text {
      transition: 0.3s;
      position: absolute;
      z-index: 9;
      bottom: 1rem;
      height: 2rem;
      width: calc(100% - 1rem);
      background-image: linear-gradient(transparent, white);
    }

    .hidden-content {
      transition: 0.4s;
      display: grid;
      grid-template-columns: auto auto;
      overflow: hidden;
      min-height: 10rem;
      max-height: 10rem;

      .icon {
        // width: 10rem;
        width: fit-content;
        margin-right: 2rem;
        border-right: 2px solid #c8c8c8;

        .label {
          font-size: 14px;
          font-weight: 500;
          width: 10rem;
          margin: 1rem auto;
        }
      }
    }

    .suggest-note {
      // width: calc(100% - 1rem);
      // margin: 0.2rem 0;
      padding: 0rem 1rem 1rem 0;
      font-size: 1.1rem;
      color: #545454;
      word-wrap: break-word;
    }

    .hidden-des {
      // width: calc(100% - 1rem);
      margin: 0.2rem 0;
      padding: 0.6rem 1rem 1rem 0;
      font-size: 1.2rem;
      color: #545454;

      margin-block-start: 0;
      margin-block-end: 0;
      padding-inline-start: 1rem;
    }
  }

  .footer {
    height: 2.7rem;
    background: #f3f3e7;
    cursor: pointer;

    span {
      transition: 0.4s;
      transform: rotate(0deg);
    }

    span.rotate {
      transform: rotate(180deg);
    }
  }
}

.suggest-package.show {
  overflow: auto;

  .hidden-content {
    min-height: 10rem;
    max-height: 100rem;
  }

  .body {
    .blur-text {
      opacity: 0;
    }
  }
}

.swiper-pagination-progressbar-active {
  background: #ffffff;
}

.swiper-pagination-progressbar {
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 5px;
  margin-top: 2rem;
}

.filterHospital {
  width: 100%;
  margin-top: 1rem;

  .hospital-input {
    border-radius: 2rem;
    align-items: center;
    margin-bottom: 1rem;
    width: 100%;

    .el-input__inner {
      font-size: 1.3rem;
      height: 3rem;
      border-radius: 1.5rem;
      // border: 0;
      // outline: 0;

      box-shadow: none;
      border: 1px solid #fff;
      background-color: #000;
      transition: 0.3s;
      box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
        5px 5px 10px rgba(163, 162, 162, 0.25);

      &:focus {
        border: 1px solid #206b5e;
        box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
          5px 5px 10px rgba(163, 162, 162, 0.25);
      }
    }
  }
}

.dialog-header {
  display: flex;

  .icon {
    .icon-background {
      background: #f2f6ff;
      width: 4rem;
      height: 4rem;
      border-radius: 15px;
    }

    .icon-background.cardiovascular {
      background: #f2f6ff;
      width: 4rem;
      height: 4rem;
      border-radius: 15px;
    }

    .icon-background.metabolic-syndrome {
      background: #ebfbec;
      width: 4rem;
      height: 4rem;
      border-radius: 15px;
    }

    .icon-background.diabetes {
      background: #f2fada;
      width: 4rem;
      height: 4rem;
      border-radius: 15px;
    }

    .icon-background.colon-cancer {
      background: #f5f3e2;
      width: 4rem;
      height: 4rem;
      border-radius: 15px;
    }

    .icon-background.stroke {
      background: #eef8fa;
      width: 4rem;
      height: 4rem;
      border-radius: 15px;
    }

    .icon-background.lung-cancer {
      background: #fcf0e8;
      width: 4rem;
      height: 4rem;
      border-radius: 15px;
    }
  }

  .risk-name {
    margin-left: 1rem;
    font-size: 18px;
    font-weight: 500;
    line-height: 23px;
    letter-spacing: 0em;
    text-align: left;
  }
}

.dialog-palette {
  .risk-header {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
  }
}

.dialog-suggest {
  .suggest-header {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
  }

  .suggest-detail {
    word-break: break-word;
  }

  .suggest-note {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: left;
    word-break: break-word;
  }
}
</style>
